(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tiles-desktop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-tiles]').forEach((section) => {
    const stage = section.querySelector('[data-tiles-stage]');
    const groups = Array.from(section.querySelectorAll('.brand-tiles__group'));
    const btns = Array.from(section.querySelectorAll('[data-marca-btn]'));
    const prevBtn = section.querySelector('[data-tiles-prev]');
    const nextBtn = section.querySelector('[data-tiles-next]');
    if (!stage || groups.length === 0) return;

    let activeIdx = groups.findIndex((g) => g.classList.contains('is-active'));
    if (activeIdx < 0) activeIdx = 0;

    const defaultBg = section.style.getPropertyValue('--tiles-bg').trim();
    let activateTimers = [];

    // Translate del stage: mide ancho REAL del grupo + gap y traslada en px.
    // Necesita px (no %) porque translateX(100%) en flex refiere al 100% del TRACK.
    function updateTranslate(idx) {
      const g = groups[0];
      if (!g) return;
      const groupWidth = g.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(stage).gap) || 0;
      stage.style.transform = `translateX(${-(idx * (groupWidth + gap))}px)`;
    }

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => updateTranslate(activeIdx), 100);
    });

    // Pause simple.
    function safePause(v) {
      try { v.pause(); } catch (e) {}
    }

    // Pause CON rewind — solo para cambio de marca (proxima vez arranca desde 0).
    function safePauseAndReset(v) {
      try { v.pause(); v.currentTime = 0; v.__loopCount = 0; } catch (e) {}
    }

    // Play simple. Si el video quedo al final (por MAX_LOOPS pause), reset a 0.
    function safePlay(v) {
      v.__loopCount = 0;
      if (v.duration && v.currentTime >= v.duration - 0.15) {
        try { v.currentTime = 0; } catch (e) {}
      }
      const p = v.play();
      if (p && typeof p.then === 'function') p.catch(() => {});
    }

    function activate(idx) {
      idx = ((idx % groups.length) + groups.length) % groups.length;

      // Pausar videos del grupo saliente con rewind (proxima vez arranca desde 0).
      if (activeIdx !== idx) {
        const outgoing = groups[activeIdx];
        if (outgoing) {
          outgoing.querySelectorAll('[data-tile-video]').forEach(safePauseAndReset);
        }
      }

      groups.forEach((g, i) => {
        const isActive = i === idx;
        g.classList.toggle('is-active', isActive);
        g.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      btns.forEach((b, i) => {
        const isActive = i === idx;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Translate del stage al grupo activo. Se mide ancho REAL del grupo
       // (flex-basis 100% del viewport) + gap y traslada en px. Necesita
       // ser en px porque `translateX(100%)` en flex refiere al 100% del
       // TRACK entero, no de un grupo (bug: se acumula mal con N marcas).
      updateTranslate(idx);
      stage.style.setProperty('--active-idx', idx);

      // Fondo de la seccion + colores 60/30/10 al color de la marca activa
      const activeGroup = groups[idx];
      const bg = activeGroup.getAttribute('data-marca-bg');
      const m60 = activeGroup.getAttribute('data-marca-60');
      const m30 = activeGroup.getAttribute('data-marca-30');
      const m10 = activeGroup.getAttribute('data-marca-10');
      const mfg = activeGroup.getAttribute('data-marca-fg');
      section.style.setProperty('--tiles-bg', bg || defaultBg);
      if (m60) section.style.setProperty('--marca-60', m60);
      if (m30) section.style.setProperty('--marca-30', m30);
      if (m10) section.style.setProperty('--marca-10', m10);
      if (mfg) section.style.setProperty('--marca-fg', mfg);

      // Autoplay STAGGERED: hero inmediato, verticales con delay entre cada uno
      // (800ms, 1600ms). El delay evita saturar red al arrancar N videos a la vez.
      // Solo con hover (desktop). Cancelable si el user cambia de marca.
      const canHover = window.matchMedia('(hover: hover)').matches;
      if (canHover) {
        const heroVideo = activeGroup.querySelector('.brand-tile--hero [data-tile-video]');
        const verticalVideos = activeGroup.querySelectorAll('.brand-tile:not(.brand-tile--hero) [data-tile-video]');

        if (heroVideo) safePlay(heroVideo);

        activateTimers.forEach(clearTimeout);
        activateTimers = [];
        verticalVideos.forEach((v, i) => {
          activateTimers.push(setTimeout(() => {
            if (v.closest('.brand-tiles__group') === activeGroup) safePlay(v);
          }, 800 + i * 800));
        });

        // Precargar (subir preload="auto") del hero del proximo grupo para
        // que la transicion a esa marca sea instantanea. No dispara .load()
        // porque abortaria el <link rel="preload">.
        const nextGroup = groups[(idx + 1) % groups.length];
        if (nextGroup && nextGroup !== activeGroup) {
          const nextHero = nextGroup.querySelector('.brand-tile--hero [data-tile-video]');
          if (nextHero && nextHero.preload !== 'auto') nextHero.preload = 'auto';
        }
      }

      activeIdx = idx;
    }

    // Click en logo = activar esa marca (o abrir su landing si ya estaba activa)
    btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        // Segundo toque sobre la marca ya elegida: abre su landing.
        if (i === activeIdx && btn.dataset.landing) {
          window.location.href = btn.dataset.landing;
          return;
        }
        activate(i);
      });
    });

    // Flechas prev/next entre marcas
    if (prevBtn) prevBtn.addEventListener('click', () => activate(activeIdx - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => activate(activeIdx + 1));

    // Keyboard: flechas izq/der cuando el foco esta en un logo (tab semantica)
    btns.forEach((btn, i) => {
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); activate(i + 1); btns[(i + 1) % btns.length].focus(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); activate(i - 1); btns[(i - 1 + btns.length) % btns.length].focus(); }
      });
    });

    // Set inicial (asegura color de fondo aplicado)
    activate(activeIdx);

    // Videos: control play/pause/reload por tile + loop manual con contador.
    // Los videos reproducen MAX_LOOPS veces, luego pausan y quedan en el ultimo
    // frame. Ventaja: llaman la atencion al inicio y despues son "estatica" -
    // cero consumo de bandwidth/GPU cuando el user solo esta navegando.
    const MAX_LOOPS = 3;
    const wasPlaying = new WeakSet();
    const allVideos = section.querySelectorAll('[data-tile-video]');
    allVideos.forEach((video) => {
      const tile = video.closest('.brand-tile');
      const btn = tile && tile.querySelector('[data-tile-video-btn]');
      if (!btn) return;
      const setState = (state) => { btn.dataset.videoState = state; };

      // loopCount vive en el video mismo (v.__loopCount) para que safePlay
      // pueda resetearlo desde cualquier lado sin necesitar acceso al scope.
      video.__loopCount = 0;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused || video.ended) safePlay(video);
        else safePause(video);
      });

      // Cross-fade poster <-> video: toggle .is-video-playing en el tile.
      // playing = video empieza a mostrar frames -> poster fade-out, video fade-in.
      // pause/ended = video oculto -> poster fade-in.
      const setPlaying = (isPlaying) => {
        if (tile) tile.classList.toggle('is-video-playing', isPlaying);
      };

      video.addEventListener('play', () => setState('playing'));
      video.addEventListener('playing', () => { setState('playing'); setPlaying(true); });
      video.addEventListener('pause', () => { setState(video.ended ? 'ended' : 'paused'); setPlaying(false); });

      // Loop manual: incrementa contador; si < MAX_LOOPS, reproduce de nuevo.
      // Al llegar a MAX_LOOPS, pausa y queda en el ultimo frame como poster.
      video.addEventListener('ended', () => {
        video.__loopCount = (video.__loopCount || 0) + 1;
        if (video.__loopCount < MAX_LOOPS) {
          try { video.currentTime = 0; } catch (err) {}
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          setState('ended');
          try { video.currentTime = Math.max(0, video.duration - 0.05); } catch (err) {}
        }
      });
    });

    // Pausa auto en visibilitychange (perf app wrapper)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        allVideos.forEach((v) => { if (!v.paused) { wasPlaying.add(v); safePause(v); } });
      } else {
        allVideos.forEach((v) => { if (wasPlaying.has(v)) { wasPlaying.delete(v); safePlay(v); } });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // ============================================================
    // Cart Page interactividad
    // ============================================================
    const section = document.querySelector('[data-cart-section]');
    if (!section) return;

    const sectionId = section.getAttribute('data-section-id');
    let currentCount = null;

    // ---------- Utilidades ----------

    const debounce = function (fn, wait) {
      let t = null;
      return function () {
        const args = arguments;
        const ctx = this;
        if (t) clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    };

    const setItemLoading = function (itemEl, isLoading) {
      if (!itemEl) return;
      if (isLoading) {
        itemEl.setAttribute('data-loading', 'true');
        const inputs = itemEl.querySelectorAll('input, button');
        inputs.forEach(function (el) { el.disabled = true; });
      } else {
        itemEl.removeAttribute('data-loading');
        const inputs = itemEl.querySelectorAll('input, button');
        inputs.forEach(function (el) { el.disabled = false; });
      }
    };

    // Reemplaza el HTML de la seccion (y de recomendaciones si esta viva)
    // con el fragmento devuelto por Section Rendering API.
    const refreshSection = function () {
      const url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // La seccion principal
          const newSection = doc.querySelector('[data-cart-section]');
          const currentSection = document.querySelector('[data-cart-section]');
          if (newSection && currentSection) {
            currentSection.replaceWith(newSection);
          }

          // El bloque de recomendaciones (viene en el mismo fragment)
          const newRecom = doc.querySelector('[data-cart-recom]');
          const currentRecom = document.querySelector('[data-cart-recom]');
          if (newRecom && currentRecom) {
            currentRecom.replaceWith(newRecom);
          }

          // Re-atar handlers a la nueva DOM.
          attachHandlers();

          // Re-cargar recomendaciones (nueva instancia de la seccion recom
          // dentro de esta page ya viene con skeleton — hay que dispararlas).
          loadRecommendations();
        })
        .catch(function () { /* silent */ });
    };

    // Notifica al header + otras secciones que el cart cambio.
    // Marcamos source='cart-page' para que nuestro propio listener
    // ignore los eventos que nosotros mismos disparamos (evita loop
    // con el listener que re-hace refreshSection al escuchar 'cart:updated').
    // Adicional: broadcast cross-tab via helper global (definido en
    // assets/product-card-actions.js).
    const notifyCartChange = function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart, source: 'cart-page' }
      }));
      try {
        if (window.NQLN && typeof window.NQLN.broadcastCartUpdate === 'function') {
          window.NQLN.broadcastCartUpdate();
        }
      } catch (_) {}
    };

    // ---------- POST /cart/change.js ----------
    const changeLine = function (lineIndex, quantity, itemEl) {
      setItemLoading(itemEl, true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          notifyCartChange(cart);
          // Si el carrito quedo vacio, reload total para el empty state.
          if (cart && cart.item_count === 0) {
            window.location.reload();
            return;
          }
          return refreshSection();
        })
        .catch(function () {
          setItemLoading(itemEl, false);
        });
    };

    // ---------- POST /cart/update.js (nota) ----------
    const updateNote = function (note) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: note })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { notifyCartChange(cart); })
        .catch(function () { /* silent */ });
    };

    // ---------- Handlers ----------
    const attachHandlers = function () {
      const items = document.querySelectorAll('[data-cart-item]');
      items.forEach(function (item) {
        const line = parseInt(item.getAttribute('data-line-index'), 10);
        const input = item.querySelector('[data-qty-input]');
        const decreaseBtn = item.querySelector('[data-qty-decrease]');
        const increaseBtn = item.querySelector('[data-qty-increase]');
        const removeBtn = item.querySelector('[data-cart-remove]');

        if (decreaseBtn && input) {
          decreaseBtn.addEventListener('click', function () {
            const current = parseInt(input.value, 10) || 0;
            const next = Math.max(0, current - 1);
            input.value = next;
            changeLine(line, next, item);
          });
        }

        if (increaseBtn && input) {
          increaseBtn.addEventListener('click', function () {
            const current = parseInt(input.value, 10) || 0;
            const next = current + 1;
            input.value = next;
            changeLine(line, next, item);
          });
        }

        if (input) {
          const onChange = debounce(function () {
            const val = Math.max(0, parseInt(input.value, 10) || 0);
            input.value = val;
            changeLine(line, val, item);
          }, 500);
          input.addEventListener('change', onChange);
        }

        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            changeLine(line, 0, item);
          });
        }
      });

      // Nota (textarea)
      const note = document.querySelector('[data-cart-note]');
      if (note) {
        note.addEventListener('blur', function () {
          updateNote(note.value);
        });
      }

      // Codigo de descuento
      const discountForm = document.querySelector('[data-discount-form]');
      if (discountForm) {
        discountForm.addEventListener('submit', function (e) {
          e.preventDefault();
          applyDiscount();
        });
      }

      const discountRemoves = document.querySelectorAll('[data-discount-remove]');
      discountRemoves.forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeDiscount(btn.getAttribute('data-discount-remove'));
        });
      });
    };

    // ---------- Codigo de descuento ----------
    // Shopify aplica el codigo via GET a /discount/CODE?redirect=/cart:
    // valida el codigo, lo guarda en la sesion, y redirige de vuelta.
    // Al volver, cart.discount_codes ya viene con el codigo aplicado.
    const applyDiscount = function () {
      const input = document.querySelector('[data-discount-input]');
      const btn = document.querySelector('[data-discount-apply]');
      const msg = document.querySelector('[data-discount-msg]');
      if (!input) return;
      const code = (input.value || '').trim();
      if (!code) {
        if (msg) {
          msg.textContent = 'Ingresa un código.';
          msg.hidden = false;
          msg.removeAttribute('data-state');
        }
        return;
      }
      if (btn) btn.disabled = true;
      if (msg) {
        msg.textContent = 'Aplicando…';
        msg.hidden = false;
        msg.setAttribute('data-state', 'success');
      }
      const path = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(path);
    };

    // Quitar codigo: intento primero via Ajax /cart/update.js con
    // discount vacio (funciona en tiendas modernas). Si falla, fallback
    // a /discount/ (Shopify limpia la sesion al no encontrar codigo).
    const removeDiscount = function (code) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && (!cart.discount_codes || !cart.discount_codes.length)) {
            refreshSection();
            notifyCartChange(cart);
          } else {
            const path = window.location.pathname + window.location.search;
            window.location.href = '/discount/?redirect=' + encodeURIComponent(path);
          }
        })
        .catch(function () {
          const path = window.location.pathname + window.location.search;
          window.location.href = '/discount/?redirect=' + encodeURIComponent(path);
        });
    };

    // ============================================================
    // Recomendaciones — mismo patron que recomendaciones-carrito
    // ============================================================
    const MAX_PRODUCTS = 6;
    const SEED_LIMIT = 3;
    const RECS_PER_SEED = 4;
    const WISHLIST_KEY = 'nqln:wishlist';

    let recomLoading = false;

    const fetchRecsWith = function (productId, intent) {
      const url = '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' + RECS_PER_SEED +
        '&intent=' + intent;
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    };

    const fetchRecs = function (productId) {
      return fetchRecsWith(productId, 'complementary').then(function (arr) {
        if (arr.length > 0) return arr;
        return fetchRecsWith(productId, 'related');
      });
    };

    const readWishlist = function () {
      try {
        const wl = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(wl) ? wl : [];
      } catch (e) {
        return [];
      }
    };

    const loadRecommendations = function () {
      const recomSection = document.querySelector('[data-cart-recom]');
      if (!recomSection || recomLoading) return;
      const track = recomSection.querySelector('[data-cart-recom-track]');
      if (!track) return;

      recomLoading = true;
      recomSection.hidden = false;
      const skeletonHTML = track.innerHTML;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          const items = cart.items || [];
          if (!items.length) {
            recomSection.hidden = true;
            recomLoading = false;
            return null;
          }

          const cartIds = items.map(function (it) { return String(it.product_id); });
          const seedIds = cartIds.slice(0, SEED_LIMIT);
          const wishlist = readWishlist();

          return Promise.all(seedIds.map(fetchRecs))
            .then(function (recArrays) {
              const seen = new Set();
              cartIds.forEach(function (id) { seen.add(id); });
              wishlist.forEach(function (id) { seen.add(String(id)); });

              const flat = [].concat.apply([], recArrays);
              const unique = [];
              for (let i = 0; i < flat.length; i++) {
                const p = flat[i];
                if (!p || !p.handle) continue;
                const pid = String(p.id);
                if (seen.has(pid)) continue;
                seen.add(pid);
                unique.push(p);
                if (unique.length >= MAX_PRODUCTS) break;
              }
              return unique;
            });
        })
        .then(function (products) {
          if (!products) return null;
          if (!products.length) {
            recomSection.hidden = true;
            return null;
          }
          return Promise.all(products.map(function (p) {
            const url = '/products/' + encodeURIComponent(p.handle) +
              '?section_id=product-card-fragment';
            return fetch(url)
              .then(function (r) { return r.ok ? r.text() : ''; })
              .catch(function () { return ''; });
          }));
        })
        .then(function (htmls) {
          if (!htmls) { recomLoading = false; return; }
          const slots = htmls.filter(Boolean).map(function (html) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;
            const inner = wrapper.querySelector('.shopify-section-product-card-fragment')
              || wrapper.querySelector('#shopify-section-product-card-fragment')
              || wrapper.firstElementChild;
            const content = inner ? inner.innerHTML : html;
            return '<div class="cart-recom__slot">' + content + '</div>';
          });
          if (!slots.length) {
            recomSection.hidden = true;
          } else {
            track.innerHTML = slots.join('');
          }
          recomLoading = false;
        })
        .catch(function () {
          if (recomSection) recomSection.hidden = true;
          recomLoading = false;
        });
    };

    // ---------- Init ----------
    attachHandlers();
    loadRecommendations();

    // Escuchar cambios de carrito desde AFUERA (ej. botón "+" de las cards
    // de recomendaciones dentro de esta misma página). Ignoramos los
    // eventos que nosotros mismos disparamos (source='cart-page').
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.source === 'cart-page') return;
      refreshSection();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-explore"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const VISITS = 'nqln:coll:visits';
    const LAST = 'nqln:cx:last';
    const read = (key) => {
      try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
    };
    const write = (key, value) => {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
    };

    document.querySelectorAll('[data-cx]').forEach((root) => {
      const list = root.querySelector('[data-cx-list]');
      const items = Array.from(root.querySelectorAll('[data-cx-item]'));
      if (!list || items.length === 0) return;

      const cur = { h: root.dataset.handle, p: root.dataset.parent, r: root.dataset.root, n: root.dataset.title };
      const limit = Number(root.dataset.limit) || 8;

      // Historial: visitas anteriores (sin la actual) y registro de esta.
      let visits = read(VISITS);
      if (!Array.isArray(visits)) visits = [];
      const past = visits.filter((v) => v && v.h && v.h !== cur.h);
      const seenHandles = new Set(past.map((v) => v.h));
      const seenParents = new Set(past.map((v) => v.p).filter(Boolean));
      const seenRoots = new Set(past.map((v) => v.r).filter(Boolean));
      write(VISITS, [{ ...cur, t: Date.now() }, ...past].slice(0, 40));

      const lastMap = read(LAST) || {};
      const lastShown = new Set(Array.isArray(lastMap[cur.h]) ? lastMap[cur.h] : []);

      // La visita mas reciente con la que esta candidata tiene relacion (para el titulo).
      const relatedVisit = (d) => past.find((v) =>
        v.h === d.handle || v.h === d.parent || v.p === d.handle || (v.p && v.p === d.parent)
      );

      const scored = items.map((el) => {
        const d = el.dataset;
        let score = (Number(d.weight) || 1) + Math.random() * 2.5;
        // Afinidad con lo visitado: la misma rama pesa mas que la misma categoria.
        const branch = seenParents.has(d.parent) || seenParents.has(d.handle) || seenHandles.has(d.parent);
        if (branch) score += 1.25;
        if (seenHandles.has(d.handle)) score += 0.75;
        if (seenRoots.has(d.root)) score += 0.5;
        // Rotacion: lo que ya se mostro aqui la ultima vez baja.
        if (lastShown.has(d.handle)) score -= 2;
        return { el, score, img: d.img, affinity: branch ? relatedVisit(d) : null };
      }).sort((a, b) => b.score - a.score);

      // Dentro de la grilla la franja se repite con otro grupo de colecciones,
      // y la distancia hasta la siguiente se duplica cada vez (ver place()).
      const grid = document.querySelector('[data-coll-grid]');
      const designMode = window.Shopify && window.Shopify.designMode;
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const rows = Number(desktop ? root.dataset.rowsDesktop : root.dataset.rowsMobile) || 0;
      const inline = Boolean(grid) && !designMode && rows > 0;
      const repeats = inline ? Math.max(1, Number(root.dataset.repeats) || 1) : 1;

      // Grupos sin repetir colecciones entre ellos ni fotos dentro de cada uno.
      const remaining = scored.slice();
      const pick = () => {
        const group = [];
        const imgs = new Set();
        for (const it of remaining) {
          if (group.length >= limit) break;
          if (it.img && imgs.has(it.img)) continue;
          group.push(it);
          if (it.img) imgs.add(it.img);
        }
        for (const it of remaining) {
          if (group.length >= limit) break;
          if (!group.includes(it)) group.push(it);
        }
        group.forEach((it) => remaining.splice(remaining.indexOf(it), 1));
        return group;
      };
      const groups = [pick()];
      for (let i = 1; i < repeats; i++) {
        const g = pick();
        if (g.length < Math.min(4, limit)) break;
        groups.push(g);
      }

      // Una copia de la franja por cada grupo extra.
      const blocks = groups.map((group, i) => {
        if (i === 0) return root;
        const copy = root.cloneNode(true);
        copy.querySelectorAll('[data-cx-item]').forEach((el) => el.remove());
        const h = copy.querySelector('[data-cx-heading]');
        if (h) {
          h.id = h.id + '-' + i;
          h.textContent = root.dataset.titleMore || h.textContent;
          copy.setAttribute('aria-labelledby', h.id);
        }
        return copy;
      });

      items.forEach((el) => { el.hidden = true; });
      const usedReasons = new Set();
      groups.forEach((group, i) => {
        const target = blocks[i].querySelector('[data-cx-list]');
        group.forEach((it) => {
          it.el.hidden = false;
          target.appendChild(it.el);
        });
        // Titulo con el motivo, si las primeras tarjetas vienen de lo visitado.
        // (Sin repetir el mismo motivo en dos franjas.)
        const reason = group.slice(0, 3).map((it) => it.affinity).find((v) => v && v.n && !usedReasons.has(v.h));
        const heading = blocks[i].querySelector('[data-cx-heading]');
        if (reason && heading) {
          // "PORQUE VISTE" como kicker NQ y el nombre de la colección grande debajo
          const kick = document.createElement('span');
          kick.className = 'nq-kicker cx__kicker';
          kick.textContent = 'Porque viste';
          const name = document.createElement('span');
          name.className = 'cx__reason';
          name.textContent = reason.n;
          heading.replaceChildren(kick, name);
          usedReasons.add(reason.h);
        }
      });

      lastMap[cur.h] = groups.flat().map((it) => it.el.dataset.handle);
      const keys = Object.keys(lastMap);
      if (keys.length > 30) delete lastMap[keys[0]];
      write(LAST, lastMap);

      // Flechas del carrusel (solo se ven con mouse, ver CSS).
      const bindNav = (block) => {
        const rail = block.querySelector('[data-cx-list]');
        const prev = block.querySelector('[data-cx-prev]');
        const next = block.querySelector('[data-cx-next]');
        if (!rail || !prev || !next) return () => {};
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          const scrollable = max > 4;
          prev.hidden = !scrollable;
          next.hidden = !scrollable;
          prev.disabled = rail.scrollLeft <= 4;
          next.disabled = rail.scrollLeft >= max - 4;
        };
        const step = (dir) => {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: dir * rail.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        return update;
      };
      const updaters = blocks.map(bindNav);

      if (!inline) {
        updaters.forEach((update) => update());
        return;
      }

      // Ubicar cada franja cuando la grilla ya tenga esos productos. El scroll
      // infinito agrega productos despues, asi que se observa la grilla hasta
      // ubicar todas.
      const cols = () => getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 2;
      const placed = new Set();
      const place = () => {
        const slots = grid.querySelectorAll('.coll-page__slot');
        blocks.forEach((block, i) => {
          if (placed.has(i)) return;
          // La distancia entre franjas se duplica: N, luego 2N mas, luego 4N mas
          // (en filas: N, 3N, 7N → desktop con 2 filas de 4: productos 8, 24, 56).
          const at = rows * (Math.pow(2, i + 1) - 1) * cols();
          // La primera se ubica aunque la coleccion tenga menos productos.
          const index = i === 0 ? Math.min(at, slots.length) : at;
          const ref = slots[index - 1];
          if (!ref || index > slots.length) return;
          block.classList.add('cx--inline', 'nq-trama-recta');
          block.querySelector('[data-cx-heading]')?.classList.add('nq-titular');
          block.querySelector('.cx__viewall')?.classList.add('nq-pildora');
          ref.after(block);
          placed.add(i);
          updaters[i]();
        });
        return placed.size === blocks.length;
      };
      if (!place()) {
        const observer = new MutationObserver(() => { if (place()) observer.disconnect(); });
        observer.observe(grid, { childList: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-coll-page]');
    if (!page) return;

    /* ---------- Sort select ---------- */
    page.querySelectorAll('[data-coll-sort]').forEach(function (form) {
      const select = form.querySelector('[data-sort-select]');
      if (!select) return;
      select.addEventListener('change', function () {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });

    /* ---------- Drawer open/close ---------- */
    const drawer = page.querySelector('[data-coll-drawer]');
    const openers = page.querySelectorAll('[data-coll-open-drawer]');
    const closers = page.querySelectorAll('[data-coll-close-drawer]');

    const supportsDialog = drawer && typeof drawer.showModal === 'function';

    const openDrawer = function () {
      if (!drawer) return;
      if (supportsDialog) {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
      }
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = function () {
      if (!drawer) return;
      if (supportsDialog && drawer.open) {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
    };

    openers.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
    closers.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });

    if (drawer) {
      drawer.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
      });
      /* Click en el backdrop cierra */
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
    }

    /* ---------- Filter form: auto-submit con debounce ---------- */
    const grid = page.querySelector('[data-coll-grid]');
    const setLoading = function (on) {
      if (grid) grid.setAttribute('data-loading', on ? '1' : '0');
    };

    page.querySelectorAll('[data-coll-filter-form]').forEach(function (form) {
      let t = null;
      const submit = function () {
        setLoading(true);
        form.submit();
      };
      form.addEventListener('change', function (e) {
        if (t) clearTimeout(t);
        /* Los checkboxes también van con debounce corto para permitir
           selección múltiple rápida sin recargar entre cada click. */
        const delay = (e.target && e.target.type === 'number') ? 500 : 350;
        t = setTimeout(submit, delay);
      });
      form.addEventListener('input', function (e) {
        if (e.target && e.target.type === 'number') {
          if (t) clearTimeout(t);
          t = setTimeout(submit, 600);
        }
      });
    });

    /* ---------- Recomendados (async, mismo pipeline que recomendaciones-carrito) ---------- */
    const recsSection = page.querySelector('[data-coll-recs]');
    if (recsSection) {
      const track = recsSection.querySelector('[data-coll-recs-track]');
      const seedId = recsSection.getAttribute('data-seed-id');
      const excludeRaw = recsSection.getAttribute('data-exclude-ids') || '';
      const excludeIds = excludeRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      const MAX_PRODUCTS = 6;

      const fetchRecsWith = function (productId, intent) {
        const url = '/recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=' + 10 +
          '&intent=' + intent;
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) { return j.products || []; })
          .catch(function () { return []; });
      };

      const fetchRecs = function (productId) {
        return fetchRecsWith(productId, 'related').then(function (arr) {
          if (arr.length > 0) return arr;
          return fetchRecsWith(productId, 'complementary');
        });
      };

      if (track && seedId) {
        const seen = new Set(excludeIds);
        fetchRecs(seedId)
          .then(function (products) {
            const unique = [];
            for (let i = 0; i < products.length; i++) {
              const p = products[i];
              if (!p || !p.handle) continue;
              const pid = String(p.id);
              if (seen.has(pid)) continue;
              seen.add(pid);
              unique.push(p);
              if (unique.length >= MAX_PRODUCTS) break;
            }
            if (!unique.length) {
              recsSection.hidden = true;
              return null;
            }
            recsSection.hidden = false;
            return Promise.all(unique.map(function (p) {
              const url = '/products/' + encodeURIComponent(p.handle) +
                '?section_id=product-card-fragment';
              return fetch(url)
                .then(function (r) { return r.ok ? r.text() : ''; })
                .catch(function () { return ''; });
            }));
          })
          .then(function (htmls) {
            if (!htmls) return;
            const slots = htmls.filter(Boolean).map(function (html) {
              const wrapper = document.createElement('div');
              wrapper.innerHTML = html;
              const inner = wrapper.querySelector('.shopify-section-product-card-fragment')
                || wrapper.querySelector('#shopify-section-product-card-fragment')
                || wrapper.firstElementChild;
              const content = inner ? inner.innerHTML : html;
              return '<div class="coll-recs__slot">' + content + '</div>';
            });
            if (!slots.length) {
              recsSection.hidden = true;
            } else {
              track.innerHTML = slots.join('');
            }
          })
          .catch(function () {
            recsSection.hidden = true;
          });
      } else {
        recsSection.hidden = true;
      }
    }
  })();

  // ==============================
  // Medir altura del header mobile y exponerla como CSS var --mobile-header-height
  // para que el toolbar sticky calcule su top correctamente sin solapar.
  // ==============================
  (function () {
    function updateHeaderHeight() {
      var header = document.querySelector('.shopify-section-header') || document.querySelector('.site-header');
      if (!header) return;
      var h = header.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--mobile-header-height', h + 'px');
      }
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    // Re-medir cuando el DOM cambia (fonts loaded, chips scroll, etc)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateHeaderHeight);
    }
  })();

  // ==============================
  // Toolbar sticky mobile:
  // 1. Sentinel + IntersectionObserver detecta cuando el toolbar esta pegado
  //    → toggle .is-stuck (fondo blanco solo cuando esta stuck, no en su
  //    posicion inicial dentro del degradado).
  // 2. Show/hide on scroll SOLO cuando esta stuck (evita saltos al inicio).
  // ==============================
  (function () {
    if (window.innerWidth >= 990) return;
    var toolbar = document.querySelector('[data-coll-toolbar]');
    if (!toolbar || !toolbar.parentNode) return;

    // Insertar sentinel invisible justo antes del toolbar
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;width:100%;pointer-events:none;';
    toolbar.parentNode.insertBefore(sentinel, toolbar);

    var isStuck = false;
    if ('IntersectionObserver' in window) {
      var stuckObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isStuck = !entry.isIntersecting;
          toolbar.classList.toggle('is-stuck', isStuck);
          if (!isStuck) toolbar.classList.remove('is-hidden');
        });
      }, {
        // rootMargin negativo top = detecta cuando el sentinel sale por arriba
        // del viewport (o sea, el toolbar quedo pegado debajo del header)
        rootMargin: '-' + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mobile-header-height'), 10) || 56) + 'px 0px 0px 0px',
        threshold: 0
      });
      stuckObs.observe(sentinel);
    }

    // Show/hide on scroll — solo cuando ya esta stuck
    var THRESHOLD_DELTA = 10;
    var lastY = window.scrollY;
    var anchorY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      if (isStuck) {
        var delta = y - anchorY;
        if (delta > THRESHOLD_DELTA) {
          toolbar.classList.add('is-hidden');
          anchorY = y;
        } else if (delta < -THRESHOLD_DELTA) {
          toolbar.classList.remove('is-hidden');
          anchorY = y;
        }
      } else {
        anchorY = y;
        toolbar.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();

  // ==============================
  // Dual-handle price slider — sincroniza handles ↔ inputs numéricos
  // ==============================
  (function () {
    document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
      var loHandle = slider.querySelector('[data-price-slider-lo]');
      var hiHandle = slider.querySelector('[data-price-slider-hi]');
      var loInput = slider.querySelector('[data-price-input-lo]');
      var hiInput = slider.querySelector('[data-price-input-hi]');
      var rangeEl = slider.querySelector('[data-price-slider-range]');
      if (!loHandle || !hiHandle || !loInput || !hiInput || !rangeEl) return;

      var maxVal = parseFloat(slider.getAttribute('data-price-max')) || 100;
      var sliderEl = slider.querySelector('.coll-filter__slider');
      var THUMB_RADIUS = 9; // 18px thumb / 2

      function paintRange() {
        var lo = parseFloat(loHandle.value) || 0;
        var hi = parseFloat(hiHandle.value) || maxVal;
        if (lo > hi) { lo = hi; loHandle.value = lo; }
        // El thumb del <input type=range> se centra a lo largo del ancho del input.
        // El track visible mide (sliderWidth - 2*thumbRadius) porque el thumb no puede
        // salirse. Calculamos posicion del centro del thumb en px absolutos.
        var w = sliderEl.offsetWidth;
        if (w <= 0) w = 200;
        var usable = w - THUMB_RADIUS * 2;
        var loCenter = THUMB_RADIUS + (lo / maxVal) * usable;
        var hiCenter = THUMB_RADIUS + (hi / maxVal) * usable;
        rangeEl.style.left = loCenter + 'px';
        rangeEl.style.width = Math.max(0, hiCenter - loCenter) + 'px';
      }

      window.addEventListener('resize', paintRange, { passive: true });

      function syncFromHandles() {
        var lo = parseFloat(loHandle.value) || 0;
        var hi = parseFloat(hiHandle.value) || maxVal;
        if (lo > hi) { hi = lo; hiHandle.value = hi; }
        loInput.value = lo;
        hiInput.value = hi;
        paintRange();
      }

      function syncFromInputs() {
        var lo = parseFloat(loInput.value);
        var hi = parseFloat(hiInput.value);
        if (isNaN(lo)) lo = 0;
        if (isNaN(hi)) hi = maxVal;
        if (lo > hi) lo = hi;
        loHandle.value = lo;
        hiHandle.value = hi;
        paintRange();
      }

      // Mover handles: input event actualiza en vivo
      loHandle.addEventListener('input', function () {
        var lo = parseFloat(loHandle.value);
        var hi = parseFloat(hiHandle.value);
        if (lo > hi) { loHandle.value = hi; }
        loInput.value = loHandle.value;
        paintRange();
      });
      hiHandle.addEventListener('input', function () {
        var lo = parseFloat(loHandle.value);
        var hi = parseFloat(hiHandle.value);
        if (hi < lo) { hiHandle.value = lo; }
        hiInput.value = hiHandle.value;
        paintRange();
      });

      // Cambiar inputs numericos manualmente
      loInput.addEventListener('input', syncFromInputs);
      hiInput.addEventListener('input', syncFromInputs);

      // Estado inicial
      paintRange();
    });
  })();

  // ==============================
  // Infinite scroll
  // ==============================
  (function () {
    var infinite = document.querySelector('[data-coll-infinite]');
    if (!infinite) return;

    var grid = document.querySelector('[data-coll-grid]');
    var status = infinite.querySelector('[data-coll-load-status]');
    var loadBtn = infinite.querySelector('[data-coll-load-btn]');
    if (!grid) return;

    var nextUrl = infinite.getAttribute('data-next-url') || '';
    var totalPages = parseInt(infinite.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(infinite.getAttribute('data-current-page'), 10) || 1;
    var loading = false;

    function setLoading(on) {
      loading = on;
      infinite.setAttribute('data-loading', on ? '1' : '0');
      if (status) status.textContent = on ? 'Cargando más productos...' : '';
    }

    function done() {
      infinite.setAttribute('data-done', '1');
      infinite.removeAttribute('data-loading');
      if (status) status.textContent = 'Has visto todos los productos.';
      if (loadBtn) loadBtn.hidden = true;
      if (observer) observer.disconnect();
    }

    function loadNext() {
      if (loading) return;
      if (!nextUrl) { done(); return; }
      setLoading(true);

      var url = nextUrl;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(getSectionId());

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var newSlots = wrapper.querySelectorAll('.coll-page__slot');
          if (newSlots.length) {
            newSlots.forEach(function (slot) { grid.appendChild(slot); });
          }
          // Actualizar next_url para el proximo fetch
          var newInfinite = wrapper.querySelector('[data-coll-infinite]');
          if (newInfinite) {
            nextUrl = newInfinite.getAttribute('data-next-url') || '';
            currentPage = parseInt(newInfinite.getAttribute('data-current-page'), 10) || currentPage + 1;
          } else {
            nextUrl = '';
          }
          setLoading(false);
          if (!nextUrl || currentPage >= totalPages) done();
        })
        .catch(function () {
          setLoading(false);
          // Mostrar boton de fallback si el fetch falla
          if (status) status.textContent = 'No se pudo cargar más productos.';
          if (loadBtn) loadBtn.hidden = false;
        });
    }

    function getSectionId() {
      // Buscar el id del wrapper .shopify-section-collection (que envuelve todo)
      var wrapper = infinite.closest('[id^="shopify-section-"]');
      if (wrapper) return wrapper.id.replace('shopify-section-', '');
      return 'collection';
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '400px 0px 400px 0px', threshold: 0 });
      observer.observe(infinite);
    } else {
      // Fallback: mostrar boton siempre
      if (loadBtn) {
        loadBtn.hidden = false;
        loadBtn.addEventListener('click', loadNext);
      }
    }

    // Boton de fallback tambien clicable si el observer esta activo
    if (loadBtn) {
      loadBtn.addEventListener('click', loadNext);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Menus del footer: acordeon cerrado en mobile, abiertos en desktop.
     (En Chrome moderno el contenido de un <details> cerrado no se puede
     mostrar solo con CSS, por eso se sincroniza el atributo open.) */
  (() => {
    const mq = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      document.querySelectorAll('[data-footer-menu]').forEach((d) => { d.open = mq.matches; });
    };
    sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-header-nav]').forEach((nav) => {
    const mega = nav.querySelector('[data-mega]');
    if (!mega) return;
    const toggle = mega.querySelector('[data-mega-toggle]');
    const panel = mega.querySelector('[data-mega-panel]');
    const links = panel ? panel.querySelectorAll('[data-mega-link]') : [];
    const panels = panel ? panel.querySelectorAll('[data-mega-panel-idx]') : [];
    if (!toggle || !panel || links.length === 0) return;

    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    const showPanel = (idx) => {
      panels.forEach((p) => (p.hidden = String(idx) !== p.dataset.megaPanelIdx));
      links.forEach((l) => l.classList.toggle('is-hover', l.dataset.megaLink === String(idx)));
      panel.classList.add('has-active-panel');
    };

    const hidePanel = () => {
      panel.classList.remove('has-active-panel');
      links.forEach((l) => l.classList.remove('is-hover'));
    };

    // Al abrir, activar el primer link CON subcategorias.
    const showFirst = () => {
      const first = Array.from(links).find((l) => l.dataset.hasPanel === 'true');
      if (first) showPanel(first.dataset.megaLink);
    };

    toggle.addEventListener('click', () => {
      if (panel.hidden) { open(); showFirst(); }
      else close();
    });

    mega.addEventListener('mouseenter', () => { open(); showFirst(); });
    mega.addEventListener('mouseleave', close);

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (link.dataset.hasPanel === 'true') {
          showPanel(link.dataset.megaLink);
        } else {
          // Sin subcategorias: colapsar el mega para que no se vea espacio en blanco
          hidePanel();
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!mega.contains(e.target) && !panel.hidden) close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-desktop"] && !Shopify.designMode) return;
  try {
    
  // Beneficios rotativos: activa uno a la vez con animacion rotateY
  document.querySelectorAll('[data-benefits-carousel]').forEach((carousel) => {
    const items = Array.from(carousel.children);
    if (items.length === 0) return;
    carousel.setAttribute('data-carousel-ready', '');
    items.forEach((el, i) => el.classList.toggle('is-active', i === 0));
    if (items.length <= 1) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    const interval = parseInt(carousel.dataset.interval, 10) || 4000;
    let cursor = 0;
    let timer = null;
    const tick = () => {
      items[cursor].classList.remove('is-active');
      cursor = (cursor + 1) % items.length;
      items[cursor].classList.add('is-active');
    };
    const start = () => { if (timer) return; timer = setInterval(tick, interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  });

  // Buscador: mostrar/ocultar el boton "clear" (X) segun contenido del input
  document.querySelectorAll('[data-header-search]').forEach((form) => {
    const input = form.querySelector('[data-search-input]');
    const clear = form.querySelector('[data-search-clear]');
    if (!input || !clear) return;

    const sync = () => { clear.hidden = input.value.length === 0; };

    input.addEventListener('input', sync);
    input.addEventListener('search', sync);

    // ---------- Predictive search ----------
    const dropdown = form.querySelector('[data-search-predictive]');
    const dropdownInner = form.querySelector('[data-search-predictive-inner]');
    const emptyEl = form.querySelector('[data-search-predictive-empty]');
    const queryEl = form.querySelector('[data-search-predictive-query]');
    // /search/suggest.json devuelve precios como STRING con formato
    // "12.34" (unidades de moneda, NO cents). Las imágenes vienen como
    // URL string absoluta directa, no objeto. Ajustamos ambos parsers.
    const money = (val) => {
      if (val == null || val === '') return '';
      const n = parseFloat(String(val).replace(',', '.'));
      if (isNaN(n)) return '';
      return '$' + n.toFixed(2);
    };
    const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
    const resolveImage = (p) => {
      const src = p.featured_image || p.image;
      if (!src) return '';
      if (typeof src === 'string') return src;
      return src.url || src.src || '';
    };
    const shouldShowCompare = (p) => {
      const price = parseFloat(p.price);
      const compare = parseFloat(p.compare_at_price_min || p.compare_at_price || 0);
      return !isNaN(price) && !isNaN(compare) && compare > price;
    };
    const discountPercent = (p) => {
      if (!shouldShowCompare(p)) return 0;
      const price = parseFloat(p.price);
      const compare = parseFloat(p.compare_at_price_min || p.compare_at_price);
      return Math.round(((compare - price) / compare) * 100);
    };
    // Mapa tag → label mostrado en el badge. Los tags de NQLN.
    const tagBadges = {
      'tendencia': 'TENDENCIA',
      'nuevo': 'NUEVO',
      'oferta': 'OFERTA',
      'semanal': 'TOP SEMANA',
      'mensual': 'TOP MES',
      'regalo': 'REGALO'
    };
    const resolveTagBadge = (p) => {
      const tags = Array.isArray(p.tags) ? p.tags : (typeof p.tags === 'string' ? p.tags.split(',') : []);
      for (let i = 0; i < tags.length; i++) {
        const t = String(tags[i]).trim().toLowerCase();
        if (tagBadges[t]) return tagBadges[t];
      }
      return '';
    };
    const buildBadges = (p) => {
      const parts = [];
      const pct = discountPercent(p);
      if (pct >= 5) {
        parts.push('<span class="header-desktop__predictive-badge header-desktop__predictive-badge--sale">-' + pct + '%</span>');
      }
      const tagLabel = resolveTagBadge(p);
      if (tagLabel) {
        parts.push('<span class="header-desktop__predictive-badge header-desktop__predictive-badge--tag">' + escapeHtml(tagLabel) + '</span>');
      }
      if (p.available === false) {
        parts.push('<span class="header-desktop__predictive-badge header-desktop__predictive-badge--out">AGOTADO</span>');
      }
      if (!parts.length) return '';
      return '<span class="header-desktop__predictive-badges">' + parts.join('') + '</span>';
    };
    const renderProducts = (products, q) => {
      if (!products.length) {
        dropdownInner.innerHTML = '';
        dropdownInner.appendChild(emptyEl);
        emptyEl.hidden = false;
        if (queryEl) queryEl.textContent = q;
        return;
      }
      emptyEl.hidden = true;
      const items = products.map((p) => {
        const img = resolveImage(p);
        const compare = shouldShowCompare(p)
          ? '<span class="header-desktop__predictive-price-compare">' + money(p.compare_at_price_min || p.compare_at_price) + '</span>'
          : '';
        const badges = buildBadges(p);
        const outClass = (p.available === false) ? ' is-out' : '';
        return '<li class="header-desktop__predictive-item' + outClass + '">' +
          '<a href="' + escapeHtml(p.url) + '">' +
            '<span class="header-desktop__predictive-media">' +
              (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="header-desktop__predictive-body">' +
              (p.vendor ? '<span class="header-desktop__predictive-vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
              '<span class="header-desktop__predictive-title">' + escapeHtml(p.title) + '</span>' +
              badges +
            '</span>' +
            '<span class="header-desktop__predictive-price">' + compare + money(p.price) + '</span>' +
          '</a>' +
        '</li>';
      }).join('');
      dropdownInner.innerHTML =
        '<ul class="header-desktop__predictive-list">' + items + '</ul>' +
        '<a class="header-desktop__predictive-view-all" href="/search?q=' + encodeURIComponent(q) + '">' +
          'Ver todos los resultados para “' + escapeHtml(q) + '”' +
        '</a>';
    };
    let currentAbort = null;
    let debounceT = null;
    const runSearch = (q) => {
      if (currentAbort) currentAbort.abort();
      currentAbort = new AbortController();
      dropdownInner.innerHTML = '<div class="header-desktop__predictive-loading">Buscando…</div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide',
        { headers: { 'Accept': 'application/json' }, signal: currentAbort.signal }
      )
        .then((r) => r.ok ? r.json() : null)
        .then((data) => {
          if (!data || !data.resources || !data.resources.results) return;
          renderProducts(data.resources.results.products || [], q);
        })
        .catch(() => {});
    };
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (!dropdown) return;
      if (q.length < 2) {
        dropdown.hidden = true;
        return;
      }
      dropdown.hidden = false;
      clearTimeout(debounceT);
      debounceT = setTimeout(() => runSearch(q), 180);
    });
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && dropdown) dropdown.hidden = false;
    });
    document.addEventListener('click', (e) => {
      if (!dropdown) return;
      if (form.contains(e.target)) return;
      dropdown.hidden = true;
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown && !dropdown.hidden) {
        dropdown.hidden = true;
        input.blur();
      }
    });

    clear.addEventListener('click', () => {
      input.value = '';
      if (dropdown) dropdown.hidden = true;
      input.focus();
      sync();
    });
    sync();
  });

  // BCV auto-update (mismo que header-info-bar)
  document.querySelectorAll('.header-desktop script[data-bcv-auto-update]').forEach((script) => {
    const endpoint = script.dataset.endpoint;
    const keyPath = script.dataset.keyPath || '';
    const target = script.previousElementSibling?.querySelector('[data-bcv-rate]');
    if (!endpoint || !target) return;
    fetch(endpoint, { headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then((data) => {
        const value = keyPath ? keyPath.split('.').reduce((obj, k) => obj?.[k], data) : data;
        if (value == null) return;
        const num = typeof value === 'number' ? value : parseFloat(value);
        if (Number.isFinite(num)) {
          target.textContent = num.toLocaleString('es-VE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-info-bar"]) return;
  try {
    
  document.querySelectorAll('[data-info-carousel]').forEach((carousel) => {
    const items = Array.from(carousel.children);
    const total = items.length;
    if (total === 0) return;
    carousel.setAttribute('data-carousel-ready', '');
    if (total <= 2) {
      items.forEach((el, i) => el.classList.add(i === 0 ? 'is-slot-1' : 'is-slot-2'));
      return;
    }
    let cursor = 0;
    const paint = () => {
      items.forEach((el) => el.classList.remove('is-slot-1', 'is-slot-2'));
      items[cursor % total].classList.add('is-slot-1');
      items[(cursor + 1) % total].classList.add('is-slot-2');
    };
    paint();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = parseInt(carousel.dataset.interval, 10) || 4000;
    let timer = null;
    const tick = () => { cursor = (cursor + 2) % total; paint(); };
    const start = () => { if (timer) return; timer = setInterval(tick, interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  });

  document.querySelectorAll('script[data-bcv-auto-update]').forEach((script) => {
    const endpoint = script.dataset.endpoint;
    const keyPath = script.dataset.keyPath || '';
    const target = script.previousElementSibling?.querySelector('[data-bcv-rate]');
    if (!endpoint || !target) return;
    fetch(endpoint, { headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then((data) => {
        const value = keyPath ? keyPath.split('.').reduce((obj, k) => obj?.[k], data) : data;
        if (value == null) return;
        const num = typeof value === 'number' ? value : parseFloat(value);
        if (Number.isFinite(num)) {
          target.textContent = num.toLocaleString('es-VE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Header behavior on scroll: hide on scroll down, show on scroll up.
  (function () {
    const headerEl = document.getElementById('Header');
    if (!headerEl) return;
    const header = headerEl.closest('.shopify-section-header') || headerEl;
    const THRESHOLD_HIDE = 20;
    const THRESHOLD_DELTA = 8;
    let lastY = window.scrollY;
    let anchorY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      // Pegado (ya pasó su propio alto): respeta la zona segura del iPhone.
      header.classList.toggle('is-stuck', y > header.offsetHeight);

      if (y < THRESHOLD_HIDE) {
        header.classList.remove('is-hidden');
        anchorY = y;
      } else {
        const delta = y - anchorY;
        if (delta > THRESHOLD_DELTA) {
          header.classList.add('is-hidden');
          anchorY = y;
        } else if (delta < -THRESHOLD_DELTA) {
          header.classList.remove('is-hidden');
          anchorY = y;
        }
        if ((y > lastY && anchorY < lastY) || (y < lastY && anchorY > lastY)) {
          anchorY = lastY;
        }
      }

      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  })();

  // ==============================
  // Búsqueda mobile (predictive)
  // ==============================
  (function () {
    const openBtn = document.querySelector('[data-mobile-search-open]');
    const panel = document.querySelector('[data-mobile-search-panel]');
    if (!openBtn || !panel) return;

    const closeBtn = panel.querySelector('[data-mobile-search-close]');
    const form = panel.querySelector('[data-mobile-search-form]');
    const input = panel.querySelector('[data-mobile-search-input]');
    const results = panel.querySelector('[data-mobile-search-results]');
    const resultsInner = panel.querySelector('[data-mobile-search-results-inner]');

    // Algunos navegadores y WebViews de Android (Redmi/MIUI) hacen zoom al
    // tocar el buscador aunque la letra sea de 16px, y el panel queda cortado
    // a los dos lados. Mientras la busqueda esta abierta se bloquea ese zoom
    // (maximum-scale=1) y al cerrar se devuelve el viewport original, asi el
    // pellizco para ampliar sigue funcionando en el resto de la tienda.
    const viewport = document.querySelector('meta[name="viewport"]');
    const viewportOriginal = viewport ? viewport.getAttribute('content') : '';
    const lockZoom = (on) => {
      if (!viewport) return;
      viewport.setAttribute('content', on ? viewportOriginal + ',maximum-scale=1' : viewportOriginal);
    };

    const open = () => {
      lockZoom(true);
      // Si la pagina habia quedado corrida a un lado, volver al borde izquierdo
      if (window.scrollX) window.scrollTo(0, window.scrollY);
      panel.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      setTimeout(() => input && input.focus(), 60);
    };
    const close = () => {
      lockZoom(false);
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      if (input) input.value = '';
      if (results) results.hidden = true;
      if (resultsInner) resultsInner.innerHTML = '';
    };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) close();
    });

    // Predictive
    const money = (val) => {
      if (val == null || val === '') return '';
      const n = parseFloat(String(val).replace(',', '.'));
      if (isNaN(n)) return '';
      return '$' + n.toFixed(2);
    };
    const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
    const resolveImage = (p) => {
      const src = p.featured_image || p.image;
      if (!src) return '';
      if (typeof src === 'string') return src;
      return src.url || src.src || '';
    };
    const discountPercent = (p) => {
      const price = parseFloat(p.price);
      const compare = parseFloat(p.compare_at_price_min || p.compare_at_price || 0);
      if (isNaN(price) || isNaN(compare) || compare <= price) return 0;
      return Math.round(((compare - price) / compare) * 100);
    };

    // Mapa tag → label del badge (mismos tags que la card de producto).
    const tagBadges = {
      'tendencia': 'TENDENCIA',
      'nuevo': 'NUEVO',
      'oferta': 'OFERTA',
      'semanal': 'TOP SEMANA',
      'mensual': 'TOP MES',
      'regalo': 'REGALO'
    };
    const resolveTagBadge = (p) => {
      const tags = Array.isArray(p.tags) ? p.tags : (typeof p.tags === 'string' ? p.tags.split(',') : []);
      for (let i = 0; i < tags.length; i++) {
        const t = String(tags[i]).trim().toLowerCase();
        if (tagBadges[t]) return tagBadges[t];
      }
      return '';
    };

    const buildBadges = (p) => {
      const parts = [];
      const pct = discountPercent(p);
      if (pct >= 5) parts.push('<span class="site-header__search-badge site-header__search-badge--sale">-' + pct + '%</span>');
      const tagLabel = resolveTagBadge(p);
      if (tagLabel) parts.push('<span class="site-header__search-badge site-header__search-badge--tag">' + escapeHtml(tagLabel) + '</span>');
      if (p.available === false) parts.push('<span class="site-header__search-badge site-header__search-badge--out">AGOTADO</span>');
      if (!parts.length) return '';
      return '<span class="site-header__search-badges">' + parts.join('') + '</span>';
    };

    const render = (products, q) => {
      if (!resultsInner) return;
      if (!products.length) {
        resultsInner.innerHTML = '<p class="site-header__search-empty">No hay resultados para “' + escapeHtml(q) + '”</p>';
        return;
      }
      const items = products.map((p) => {
        const img = resolveImage(p);
        const pct = discountPercent(p);
        const compare = pct > 0
          ? '<span class="site-header__search-price-compare">' + money(p.compare_at_price_min || p.compare_at_price) + '</span>'
          : '';
        const badges = buildBadges(p);
        const outClass = (p.available === false) ? ' is-out' : '';
        return '<li class="site-header__search-item' + outClass + '">' +
          '<a href="' + escapeHtml(p.url) + '">' +
            '<span class="site-header__search-media">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="site-header__search-body">' +
              '<span class="site-header__search-title">' + escapeHtml(p.title) + '</span>' +
              badges +
              '<span class="site-header__search-price">' + compare + money(p.price) + '</span>' +
            '</span>' +
          '</a>' +
        '</li>';
      }).join('');
      resultsInner.innerHTML =
        '<ul class="site-header__search-list">' + items + '</ul>' +
        '<a class="site-header__search-view-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados</a>';
    };

    let ctrl = null;
    let dT = null;
    const runSearch = (q) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      resultsInner.innerHTML = '<p class="site-header__search-loading">Buscando…</p>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide',
        { headers: { 'Accept': 'application/json' }, signal: ctrl.signal }
      )
        .then((r) => r.ok ? r.json() : null)
        .then((data) => {
          if (!data || !data.resources || !data.resources.results) return;
          render(data.resources.results.products || [], q);
        })
        .catch(() => {});
    };

    if (input) {
      input.addEventListener('input', () => {
        const q = input.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          return;
        }
        results.hidden = false;
        clearTimeout(dT);
        dT = setTimeout(() => runSearch(q), 180);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const panels = carousel.querySelectorAll('[data-brand-panel]');
    const tabs = carousel.querySelectorAll('[data-brand-tab]');
    if (panels.length === 0) return;

    const autoRotate = carousel.dataset.autoRotate === 'true';
    const interval = parseInt(carousel.dataset.interval, 10) || 5000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let activeBrandIdx = 0;
    let rotateTimer = null;
    let paused = false;
    let videoPlaying = false;

    // Coverflow: asigna clases relativas al slide activo.
    // Position en circular: distancia + o - al idx activo, con wrap.
    const setActiveSlide = (panel, targetIdx) => {
      const slides = panel.querySelectorAll('.hero-brand-slide');
      const dots = panel.querySelectorAll('[data-dot]');
      const total = slides.length;
      if (total === 0) return;
      const idx = ((targetIdx % total) + total) % total;

      slides.forEach((s, i) => {
        s.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');
        let diff = i - idx;
        // Wrap circular: si N=5 y activo=0, el ultimo (4) debe ser is-prev (diff=-1 no diff=4)
        if (diff > total / 2) diff -= total;
        if (diff < -total / 2) diff += total;

        if (diff === 0) s.classList.add('is-active');
        else if (diff === -1) s.classList.add('is-prev');
        else if (diff === 1) s.classList.add('is-next');
        else if (diff === -2) s.classList.add('is-far-prev');
        else if (diff === 2) s.classList.add('is-far-next');
        // diff > |2| queda sin clase = oculto (opacity 0)

        s.setAttribute('aria-hidden', String(diff !== 0));

        // Pausar video del slide que ya no es activo
        if (diff !== 0) {
          const v = s.querySelector('[data-slide-video]');
          if (v && !v.paused) v.pause();
        }
      });
      videoPlaying = false;

      dots.forEach((d, i) => {
        const active = i === idx;
        d.classList.toggle('is-active', active);
        if (active) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });

      panel.dataset.currentSlide = String(idx);
    };

    // Click en slide adyacente (is-prev, is-next) → navegar a ese slide
    const bindSlideClick = (panel) => {
      const slides = panel.querySelectorAll('.hero-brand-slide');
      slides.forEach((slide, i) => {
        slide.addEventListener('click', (e) => {
          if (slide.classList.contains('is-active')) return;
          setActiveSlide(panel, i);
          startAutoRotate();
        });
      });
    };

    // Swipe táctil manual
    const bindSwipe = (panel) => {
      const track = panel.querySelector('.hero-brand-panel__slides');
      if (!track) return;
      let startX = 0;
      let startY = 0;
      let tracking = false;
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (!tracking) return;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        tracking = false;
        // Solo swipe horizontal, umbral 40px
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          const currentIdx = parseInt(panel.dataset.currentSlide || '0', 10);
          setActiveSlide(panel, dx < 0 ? currentIdx + 1 : currentIdx - 1);
          startAutoRotate();
        }
      }, { passive: true });
    };

    const setActiveBrand = (idx) => {
      activeBrandIdx = idx;
      panels.forEach((p, i) => {
        const active = i === idx;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-hidden', String(!active));
      });
      tabs.forEach((t, i) => {
        const active = i === idx;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      const activePanel = panels[idx];
      if (activePanel) {
        setActiveSlide(activePanel, 0);
        // Propaga el color del brand activo a CSS var global (root)
        // para que la info-bar del header lo pueda usar como fondo.
        const brandBg = activePanel.style.getPropertyValue('--brand-bg').trim();
        if (brandBg) {
          document.documentElement.style.setProperty('--brand-active-bg', brandBg);
          document.documentElement.classList.add('has-brand-bg');
        }

        // Precargar (sin reproducir) el video del primer slide de la marca
        // SIGUIENTE. Al cambiar de brand, el video ya esta en cache del navegador
        // y el poster se pinta al instante (menos "se pega").
        const nextPanel = panels[(idx + 1) % panels.length];
        if (nextPanel && nextPanel !== activePanel) {
          const nextVideo = nextPanel.querySelector('[data-slide-video]');
          if (nextVideo && nextVideo.dataset.preloadHinted !== 'true') {
            nextVideo.dataset.preloadHinted = 'true';
            try { nextVideo.preload = 'auto'; nextVideo.load(); } catch (e) {}
          }
        }
      }
    };

    const nextSlide = () => {
      const activePanel = panels[activeBrandIdx];
      if (!activePanel) return;
      const currentIdx = parseInt(activePanel.dataset.currentSlide || '0', 10);
      setActiveSlide(activePanel, currentIdx + 1);
    };

    const startAutoRotate = () => {
      if (!autoRotate || reducedMotion) return;
      stopAutoRotate();
      rotateTimer = setInterval(() => {
        if (!paused && !videoPlaying) nextSlide();
      }, interval);
    };

    // Video controls: play/pause/reload en la esquina del card.
    // Mientras el video corre, pausa el auto-rotate hasta terminar.
    const bindVideos = (panel) => {
      panel.querySelectorAll('[data-slide-video]').forEach((video) => {
        const slide = video.closest('.hero-brand-slide');
        const btn = slide && slide.querySelector('[data-video-btn]');
        if (!btn) return;

        const setState = (state) => { btn.dataset.videoState = state; };

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          if (video.ended || video.currentTime >= video.duration - 0.1) {
            video.currentTime = 0;
            video.play().catch(() => {});
          } else if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        // Cross-fade poster <-> video: toggle .is-video-playing en el slide.
        const setPlaying = (isPlaying) => {
          if (slide) slide.classList.toggle('is-video-playing', isPlaying);
        };

        video.addEventListener('play', () => { setState('playing'); videoPlaying = true; });
        video.addEventListener('playing', () => { setState('playing'); videoPlaying = true; setPlaying(true); });
        video.addEventListener('pause', () => {
          if (video.ended) setState('ended');
          else setState('paused');
          videoPlaying = false;
          setPlaying(false);
        });
        video.addEventListener('ended', () => { setState('ended'); videoPlaying = false; setPlaying(false); });
      });
    };

    const stopAutoRotate = () => {
      if (rotateTimer) clearInterval(rotateTimer);
      rotateTimer = null;
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        // Segundo toque sobre la marca ya elegida: abre su landing.
        if (i === activeBrandIdx && tab.dataset.landing) {
          window.location.href = tab.dataset.landing;
          return;
        }
        setActiveBrand(i);
        startAutoRotate();
      });
    });

    panels.forEach((panel, brandIdx) => {
      panel.querySelectorAll('[data-dot]').forEach((dot, slideIdx) => {
        dot.addEventListener('click', () => {
          if (brandIdx === activeBrandIdx) {
            setActiveSlide(panel, slideIdx);
            startAutoRotate();
          }
        });
      });
    });

    carousel.addEventListener('mouseenter', () => { paused = true; });
    carousel.addEventListener('mouseleave', () => { paused = false; });
    carousel.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    carousel.addEventListener('touchend', () => { setTimeout(() => { paused = false; }, interval); }, { passive: true });

    panels.forEach((p) => {
      setActiveSlide(p, 0);
      bindSwipe(p);
      bindSlideClick(p);
      bindVideos(p);
    });
    setActiveBrand(0);
    startAutoRotate();

    // Pausar auto-rotate cuando el tab pierde foco (evita tick fantasma).
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoRotate();
      else startAutoRotate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-antes-despues"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('landing-ba')) return;

    class LandingBa extends HTMLElement {
      connectedCallback() {
        this.knob = this.querySelector('[data-lxba-knob]');
        this.pos = 50;
        let dragging = false;

        this.addEventListener('pointerdown', (e) => {
          dragging = true;
          this.setPointerCapture(e.pointerId);
          this.fromX(e.clientX);
        });
        this.addEventListener('pointermove', (e) => { if (dragging) this.fromX(e.clientX); });
        this.addEventListener('pointerup', () => { dragging = false; });
        this.addEventListener('pointercancel', () => { dragging = false; });

        this.knob?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.set(this.pos - 5); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.set(this.pos + 5); }
          if (e.key === 'Home') { e.preventDefault(); this.set(4); }
          if (e.key === 'End') { e.preventDefault(); this.set(96); }
        });
      }

      fromX(clientX) {
        const r = this.getBoundingClientRect();
        this.set(((clientX - r.left) / r.width) * 100);
      }

      set(p) {
        this.pos = Math.max(4, Math.min(96, p));
        this.style.setProperty('--ba-pos', this.pos + '%');
        this.classList.add('is-used');
        this.knob?.setAttribute('aria-valuenow', String(Math.round(this.pos)));
      }
    }

    customElements.define('landing-ba', LandingBa);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-catalogo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('landing-catalogo')) return;

    class LandingCatalogo extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-lxc-filter]'));
        this.slots = Array.from(this.querySelectorAll('[data-lxc-cat]'));
        this.chips.forEach((chip) => chip.addEventListener('click', () => this.filter(chip)));
      }

      filter(chip) {
        const key = chip.dataset.lxcFilter;
        this.chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.slots.forEach((slot) => {
          slot.hidden = !(key === 'all' || slot.dataset.lxcCat === key);
        });
      }
    }

    customElements.define('landing-catalogo', LandingCatalogo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-iconos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-liconos]').forEach((root) => {
      const list = root.querySelector('[data-liconos-list]');
      const dots = Array.from(root.querySelectorAll('[data-liconos-dot]'));
      if (!list || dots.length === 0) return;
      const items = Array.from(list.children);

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const item = items[i];
          if (item) list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        });
      });

      list.addEventListener('scroll', () => {
        const index = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-lookbook"] && !Shopify.designMode) return;
  try {
    
  class LandingLookbook extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-llook-scenes]');
      if (!this.list) return;
      this.scenes = Array.from(this.list.children);
      this.dots = Array.from(this.querySelectorAll('[data-llook-dot]'));
      this.prev = this.querySelector('[data-llook-prev]');
      this.next = this.querySelector('[data-llook-next]');
      this.backdrop = this.querySelector('[data-llook-backdrop]');
      this.pop = this.querySelector('[data-llook-pop]');
      this.rail = this.querySelector('.llook__rail');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.openCard = null;
      this.openPin = null;
      this.cardHome = null;

      // Boton cerrar de la tarjeta (uno solo, vive en el contenedor).
      if (this.pop) {
        this.closeBtn = document.createElement('button');
        this.closeBtn.type = 'button';
        this.closeBtn.className = 'llook__pop-close';
        this.closeBtn.setAttribute('aria-label', 'Cerrar');
        this.closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6L6 18M6 6l12 12"/></svg>';
        this.closeBtn.addEventListener('click', () => this.closeCard(true));
        this.pop.appendChild(this.closeBtn);
      }

      this.onScroll = () => {
        this.syncNav();
        // Al deslizar de escena la tarjeta quedaria flotando sobre otra: se cierra.
        if (this.openCard) this.closeCard();
      };
      this.onResize = () => { if (this.openCard) this.closeCard(); };
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.openCard) this.closeCard(true);
      };
      this.onDocClick = (event) => {
        if (!this.openCard) return;
        if (this.pop && this.pop.contains(event.target)) return;
        if (this.openPin && this.openPin.contains(event.target)) return;
        this.closeCard();
      };

      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.llookDot)));
      });
      this.querySelectorAll('[data-llook-pin]').forEach((pin) => {
        pin.addEventListener('click', () => this.togglePin(pin));
      });

      this.syncNav();
    }

    disconnectedCallback() {
      if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
    }

    currentIndex() {
      return Math.round(this.list.scrollLeft / Math.max(1, this.list.clientWidth));
    }

    goTo(index) {
      const scene = this.scenes[index];
      if (!scene) return;
      this.closeCard();
      this.list.scrollTo({
        left: scene.offsetLeft - this.list.offsetLeft,
        behavior: this.reduce ? 'auto' : 'smooth'
      });
    }

    step(dir) {
      const max = this.scenes.length - 1;
      const index = Math.min(max, Math.max(0, this.currentIndex() + dir));
      this.goTo(index);
    }

    syncNav() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (this.prev) this.prev.disabled = index <= 0;
      if (this.next) this.next.disabled = index >= this.scenes.length - 1;
    }

    togglePin(pin) {
      const card = document.getElementById(pin.getAttribute('aria-controls'));
      if (!card || !this.pop) return;
      if (this.openCard === card) {
        this.closeCard();
        return;
      }
      this.closeCard();

      // Mover la tarjeta al contenedor flotante (y recordar donde estaba).
      this.cardHome = card.parentElement;
      this.pop.insertBefore(card, this.closeBtn);
      card.hidden = false;
      this.pop.hidden = false;
      pin.setAttribute('aria-expanded', 'true');
      this.openCard = card;
      this.openPin = pin;

      if (this.mobile.matches) {
        if (this.backdrop) this.backdrop.hidden = false;
      } else {
        this.placePop(pin);
      }
    }

    // Desktop: la tarjeta va al costado del punto con mas espacio y siempre
    // dentro de la escena; despues se asegura que no quede bajo el header fijo.
    placePop(pin) {
      const gap = 14;
      const rail = this.rail.getBoundingClientRect();
      const p = pin.getBoundingClientRect();
      const w = this.pop.offsetWidth;
      const h = this.pop.offsetHeight;
      const cx = p.left + p.width / 2 - rail.left;
      const cy = p.top + p.height / 2 - rail.top;

      let left = cx + p.width / 2 + gap;
      if (left + w > rail.width - 8) left = cx - p.width / 2 - gap - w;
      left = Math.max(8, Math.min(left, rail.width - w - 8));

      let top = cy - h / 2;
      top = Math.max(8, Math.min(top, rail.height - h - 8));

      this.pop.style.left = left + 'px';
      this.pop.style.top = top + 'px';
      this.pop.scrollIntoView({ block: 'nearest', behavior: this.reduce ? 'auto' : 'smooth' });
    }

    closeCard(returnFocus) {
      const pin = this.openPin;
      if (this.openCard) {
        this.openCard.hidden = true;
        if (this.cardHome) this.cardHome.appendChild(this.openCard);
      }
      if (pin) pin.setAttribute('aria-expanded', 'false');
      if (this.pop) this.pop.hidden = true;
      if (this.backdrop) this.backdrop.hidden = true;
      this.openCard = null;
      this.openPin = null;
      this.cardHome = null;
      if (returnFocus && pin) pin.focus();
    }
  }
  if (!customElements.get('landing-lookbook')) {
    customElements.define('landing-lookbook', LandingLookbook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('landing-slider')) return;

    class LandingSlider extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-lxs-stage]');
        this.slides = Array.from(this.querySelectorAll('[data-lxs-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-lxs-dot]'));
        this.current = 0;
        this.timer = null;
        this.visible = false;
        this.hovered = false;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.delay = Number(this.dataset.intervalo) || 7000;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduce && this.slides.length > 1;

        this.onKey = (e) => {
          if (e.key === 'ArrowLeft') { this.go(this.current - 1); this.restart(); }
          if (e.key === 'ArrowRight') { this.go(this.current + 1); this.restart(); }
        };
        this.onVisibility = () => this.sync();

        if (this.slides.length > 1) {
          this.querySelector('[data-lxs-prev]')?.addEventListener('click', () => { this.go(this.current - 1); this.restart(); });
          this.querySelector('[data-lxs-next]')?.addEventListener('click', () => { this.go(this.current + 1); this.restart(); });
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
          this.stage.addEventListener('keydown', this.onKey);
          this.bindSwipe();
        }

        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
        this.addEventListener('focusin', () => { this.hovered = true; this.sync(); });
        this.addEventListener('focusout', () => { this.hovered = false; this.sync(); });
        document.addEventListener('visibilitychange', this.onVisibility);

        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.25 });
        this.io.observe(this);

        this.bindCounters();

        // Editor de temas: al elegir una diapositiva, mostrarla
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target.closest('[data-lxs-slide]'));
          if (i > -1) { this.go(i); this.stop(); }
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stop();
        this.io?.disconnect();
        this.statsIo?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(index) {
        const n = this.slides.length;
        this.current = (index + n) % n;
        this.slides.forEach((slide, i) => {
          const on = i === this.current;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('inert', !on);
          if (on) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => {
          dot.classList.remove('is-active');
          dot.removeAttribute('aria-current');
          if (i === this.current) {
            void dot.offsetWidth; // reinicia la barra de progreso
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          }
        });
      }

      sync() {
        const run = this.autoplay && this.visible && !this.hovered && !document.hidden;
        if (run && !this.timer) this.start();
        else if (!run && this.timer) this.stop();
      }

      start() {
        this.stop();
        this.toggleAttribute('data-playing', true);
        this.timer = setInterval(() => this.go(this.current + 1), this.delay);
        // reinicia la barra de progreso del punto activo
        const dot = this.dots[this.current];
        if (dot) { dot.classList.remove('is-active'); void dot.offsetWidth; dot.classList.add('is-active'); }
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
        this.removeAttribute('data-playing');
      }

      restart() {
        if (!this.timer) return;
        this.start();
      }

      bindSwipe() {
        let startX = null;
        let dx = 0;
        this.stage.addEventListener('pointerdown', (e) => {
          if (e.target.closest('a, button')) return;
          startX = e.clientX;
          dx = 0;
        });
        this.stage.addEventListener('pointermove', (e) => {
          if (startX !== null) dx = e.clientX - startX;
        });
        const end = () => {
          if (startX === null) return;
          if (Math.abs(dx) > 60) { this.go(this.current + (dx < 0 ? 1 : -1)); this.restart(); }
          startX = null;
        };
        this.stage.addEventListener('pointerup', end);
        this.stage.addEventListener('pointercancel', () => { startX = null; });
        this.stage.addEventListener('pointerleave', end);
      }

      bindCounters() {
        const box = this.querySelector('[data-lxs-stats]');
        if (!box || this.reduce) return;
        const els = Array.from(box.querySelectorAll('[data-lxs-count]'));
        this.statsIo = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.statsIo.disconnect();
          els.forEach((el) => {
            const m = el.dataset.lxsCount.match(/^(\d+)(.*)$/);
            if (!m) return;
            const target = Number(m[1]);
            const suffix = m[2];
            let t0 = null;
            const tick = (ts) => {
              if (!t0) t0 = ts;
              const p = Math.min((ts - t0) / 1200, 1);
              el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
        }, { threshold: 0.3 });
        this.statsIo.observe(box);
      }
    }

    customElements.define('landing-slider', LandingSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-tabs-productos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ltabs]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-ltabs-tab]'));
      const panels = Array.from(root.querySelectorAll('.ltabs__panel'));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const activate = (index, focus) => {
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].hidden = !on;
        });
        // El panel recién mostrado no tenía ancho: arma sus dots ahora.
        const shown = panels[index];
        if (shown && shown.__ltabsDots) shown.__ltabsDots();
        const sl = shown && shown.querySelector('[data-ltabs-list]');
        if (sl) sl.dispatchEvent(new Event('scroll'));
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(i, false));
        tab.addEventListener('keydown', (event) => {
          let target = null;
          if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          if (target !== null) {
            event.preventDefault();
            activate(target, true);
          }
        });
      });

      // Flechas del carrusel de cada panel (solo visibles con mouse, ver CSS).
      panels.forEach((panel) => {
        const list = panel.querySelector('[data-ltabs-list]');
        const prev = panel.querySelector('[data-ltabs-prev]');
        const next = panel.querySelector('[data-ltabs-next]');
        if (!list || !prev || !next) return;
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          prev.disabled = list.scrollLeft <= 4;
          next.disabled = list.scrollLeft >= max - 4;
        };
        // Páginas = grupos de las tarjetas que entran a lo ancho. Se navega a la
        // posición exacta de la primera tarjeta de cada página: con scroll-snap
        // obligatorio, un scrollBy relativo en mobile vuelve al inicio.
        const cards = Array.from(list.children);
        const perPage = () => {
          const c = cards[0];
          if (!c || !c.offsetWidth) return 1;
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          return Math.max(1, Math.round((list.clientWidth + gap) / (c.offsetWidth + gap)));
        };
        const pages = () => Math.max(1, Math.ceil(cards.length / perPage()));
        const pageLeft = (i) => {
          const c = cards[Math.min(cards.length - 1, i * perPage())];
          return c ? c.offsetLeft - cards[0].offsetLeft : 0;
        };
        const currentPage = () => {
          const max = list.scrollWidth - list.clientWidth;
          if (list.scrollLeft >= max - 4) return pages() - 1;
          const per = perPage();
          const c = cards[per];
          const pageW = c ? c.offsetLeft - cards[0].offsetLeft : list.clientWidth;
          return Math.round(list.scrollLeft / Math.max(1, pageW));
        };
        const goTo = (i) => {
          const n = pages();
          const target = Math.max(0, Math.min(n - 1, i));
          list.scrollTo({ left: pageLeft(target), behavior: reduce ? 'auto' : 'smooth' });
        };
        const step = (dir) => goTo(currentPage() + dir);

        // Dots: una por página (lo que entra en el ancho visible).
        const dotsBox = panel.querySelector('[data-ltabs-dots]');
        let dots = [];
        const buildDots = () => {
          if (!dotsBox) return;
          const n = list.clientWidth ? pages() : 0;
          if (n === dots.length) return;
          dotsBox.textContent = '';
          dots = [];
          for (let i = 0; i < n; i += 1) {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'ltabs__dot';
            d.setAttribute('aria-label', 'Página ' + (i + 1) + ' de ' + n);
            d.addEventListener('click', () => goTo(i));
            dotsBox.appendChild(d);
            dots.push(d);
          }
          dotsBox.hidden = n < 2;
        };
        const markDot = () => {
          if (!dots.length) return;
          const idx = currentPage();
          dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        };
        panel.__ltabsDots = () => { buildDots(); markDot(); };
        prev.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        list.addEventListener('scroll', () => { update(); markDot(); }, { passive: true });
        update();
        panel.__ltabsDots();
      });
      window.addEventListener('resize', () => {
        panels.forEach((panel) => {
          const list = panel.querySelector('[data-ltabs-list]');
          const prev = panel.querySelector('[data-ltabs-prev]');
          const next = panel.querySelector('[data-ltabs-next]');
          if (!list || !prev || !next) return;
          const max = list.scrollWidth - list.clientWidth;
          prev.disabled = list.scrollLeft <= 4;
          next.disabled = list.scrollLeft >= max - 4;
          if (panel.__ltabsDots) panel.__ltabsDots();
        });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-testimonios"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ltesti]').forEach((root) => {
      const list = root.querySelector('[data-ltesti-list]');
      const dots = Array.from(root.querySelectorAll('[data-ltesti-dot]'));
      const prev = root.querySelector('[data-ltesti-prev]');
      const next = root.querySelector('[data-ltesti-next]');
      if (!list) return;
      const items = Array.from(list.children);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const goTo = (index) => {
        const item = items[index];
        if (item) list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      };
      const current = () => Math.round(list.scrollLeft / Math.max(1, list.clientWidth));

      if (prev) prev.addEventListener('click', () => goTo(Math.max(0, current() - 1)));
      if (next) next.addEventListener('click', () => goTo(Math.min(items.length - 1, current() + 1)));
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

      list.addEventListener('scroll', () => {
        const index = current();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });

      // Autoplay: solo si esta activo y sin prefers-reduced-motion. Se pausa
      // con hover, foco o pestana oculta, y se limpia el intervalo al pausar.
      if (root.dataset.autoplay !== 'true' || reduce || items.length < 2) return;
      const intervalo = Math.max(4, Number(root.dataset.intervalo) || 6) * 1000;
      let timer = null;
      const start = () => {
        if (timer) return;
        timer = setInterval(() => {
          goTo(current() >= items.length - 1 ? 0 : current() + 1);
        }, intervalo);
      };
      const stop = () => {
        if (timer) clearInterval(timer);
        timer = null;
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landing-videos')) {
    class LandingVideos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-lvid-track]');
        this.prev = this.querySelector('[data-lvid-prev]');
        this.next = this.querySelector('[data-lvid-next]');
        if (!this.track) return;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onPause = () => { this.paused = true; };
        this.onResume = () => { this.paused = false; };

        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        ['pointerenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, this.onPause, { passive: true }));
        ['pointerleave', 'focusout'].forEach((e) => this.addEventListener(e, this.onResume));

        // Las flechas solo se muestran si hay videos fuera de vista
        this.nav = this.querySelector('.lvid__nav');
        this.ro = new ResizeObserver(() => {
          if (this.nav) this.nav.hidden = this.track.scrollWidth <= this.track.clientWidth + 4;
        });
        this.ro.observe(this.track);

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Cada video se descarga y reproduce solo mientras esta en pantalla
        const videos = Array.from(this.querySelectorAll('[data-lvid-video]'));
        if (videos.length && !reduce) {
          this.videoIo = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) {
                const p = target.play();
                if (p && typeof p.catch === 'function') p.catch(() => {});
              } else {
                target.pause();
              }
            });
          }, { threshold: 0.5 });
          videos.forEach((v) => this.videoIo.observe(v));
        } else {
          // Con movimiento reducido: el video queda quieto y con controles
          videos.forEach((v) => { v.controls = true; v.preload = 'metadata'; });
        }

        if (this.dataset.autoplay === 'true' && !reduce) {
          this.io = new IntersectionObserver(([entry]) => {
            entry.isIntersecting ? this.start() : this.stop();
          });
          this.io.observe(this);
        }
      }

      disconnectedCallback() {
        this.stop();
        this.io?.disconnect();
        this.videoIo?.disconnect();
        this.ro?.disconnect();
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
      }

      step() {
        const cell = this.track.querySelector('.lvid__cell');
        if (!cell) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return cell.getBoundingClientRect().width + gap;
      }

      atEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      }

      go(dir) {
        if (dir > 0 && this.atEnd()) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (dir < 0 && this.track.scrollLeft <= 4) {
          this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
        }
      }

      start() {
        if (this.timer) return;
        const ms = Math.max(2000, parseInt(this.dataset.intervalo, 10) || 4000);
        this.timer = setInterval(() => {
          if (this.paused || document.hidden) return;
          this.go(1);
        }, ms);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('landing-videos', LandingVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marcas-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizar = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const iniciar = (raiz) => {
      const input = raiz.querySelector('[data-mkx-search]');
      if (!input || input.dataset.listo) return;
      input.dataset.listo = '1';
      const items = raiz.querySelectorAll('[data-mkx-item]');
      const vacio = raiz.querySelector('[data-mkx-empty]');
      input.addEventListener('input', () => {
        const q = normalizar(input.value.trim());
        let visibles = 0;
        items.forEach((li) => {
          const coincide = !q || normalizar(li.dataset.nombre || '').includes(q);
          li.hidden = !coincide;
          if (coincide) visibles += 1;
        });
        if (vacio) vacio.hidden = visibles > 0;
      });
    };
    const arrancar = () => document.querySelectorAll('.mkx').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
    document.addEventListener('shopify:section:load', arrancar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofertas-relampago"] && !Shopify.designMode) return;
  try {
    
  // Electric Border — canvas con noise 2D deformando un rectangulo redondeado.
  // Portado de https://reactbits.dev/animations/electric-border
  (function initElectricBorders() {
    document.querySelectorAll('[data-electric-border]').forEach((container) => {
      if (container.dataset.ebInit === '1') return;
      container.dataset.ebInit = '1';

      const canvas = container.querySelector('.eb-canvas');
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const cs = getComputedStyle(container);
      const colors = ['--eb-c1', '--eb-c2', '--eb-c3', '--eb-c4']
        .map((k) => cs.getPropertyValue(k).trim())
        .filter(Boolean);
      if (colors.length === 0) colors.push('#5227FF');
      const radiusStr = cs.getPropertyValue('--eb-radius').trim() || '16px';
      const borderRadius = parseFloat(radiusStr) || 16;
      const speedSec = parseFloat(cs.getPropertyValue('--eb-speed').trim()) || 6;
      const speed = 1;
      const chaos = 0.1;
      // Velocidad de rotacion del gradient multicolor (vueltas por segundo)
      const rotationSpeed = (Math.PI * 2) / speedSec;

      const octaves = 10;
      const lacunarity = 1.6;
      const gain = 0.7;
      const amplitude = chaos;
      const frequency = 10;
      const baseFlatness = 0;
      const displacement = 60;
      const borderOffset = 60;

      let time = 0;
      let lastTime = 0;
      let width = 0;
      let height = 0;
      let lastDpr = Math.min(window.devicePixelRatio || 1, 2);
      let raf = null;

      const random = (x) => (Math.sin(x * 12.9898) * 43758.5453) % 1;

      const noise2D = (x, y) => {
        const i = Math.floor(x);
        const j = Math.floor(y);
        const fx = x - i;
        const fy = y - j;
        const a = random(i + j * 57);
        const b = random(i + 1 + j * 57);
        const c = random(i + (j + 1) * 57);
        const d = random(i + 1 + (j + 1) * 57);
        const ux = fx * fx * (3 - 2 * fx);
        const uy = fy * fy * (3 - 2 * fy);
        return a * (1 - ux) * (1 - uy) + b * ux * (1 - uy) + c * (1 - ux) * uy + d * ux * uy;
      };

      const octavedNoise = (x, t, seed) => {
        let y = 0;
        let amp = amplitude;
        let freq = frequency;
        for (let i = 0; i < octaves; i++) {
          let oa = amp;
          if (i === 0) oa *= baseFlatness;
          y += oa * noise2D(freq * x + seed * 100, t * freq * 0.3);
          freq *= lacunarity;
          amp *= gain;
        }
        return y;
      };

      const cornerPoint = (cx, cy, r, start, arc, p) => {
        const a = start + p * arc;
        return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
      };

      const roundedRectPoint = (t, left, top, w, h, r) => {
        const sw = w - 2 * r;
        const sh = h - 2 * r;
        const ca = (Math.PI * r) / 2;
        const perim = 2 * sw + 2 * sh + 4 * ca;
        const d = t * perim;
        let acc = 0;
        if (d <= acc + sw) { const p = (d - acc) / sw; return { x: left + r + p * sw, y: top }; }
        acc += sw;
        if (d <= acc + ca) { const p = (d - acc) / ca; return cornerPoint(left + w - r, top + r, r, -Math.PI / 2, Math.PI / 2, p); }
        acc += ca;
        if (d <= acc + sh) { const p = (d - acc) / sh; return { x: left + w, y: top + r + p * sh }; }
        acc += sh;
        if (d <= acc + ca) { const p = (d - acc) / ca; return cornerPoint(left + w - r, top + h - r, r, 0, Math.PI / 2, p); }
        acc += ca;
        if (d <= acc + sw) { const p = (d - acc) / sw; return { x: left + w - r - p * sw, y: top + h }; }
        acc += sw;
        if (d <= acc + ca) { const p = (d - acc) / ca; return cornerPoint(left + r, top + h - r, r, Math.PI / 2, Math.PI / 2, p); }
        acc += ca;
        if (d <= acc + sh) { const p = (d - acc) / sh; return { x: left, y: top + h - r - p * sh }; }
        acc += sh;
        const p = (d - acc) / ca;
        return cornerPoint(left + r, top + r, r, Math.PI, Math.PI / 2, p);
      };

      const updateSize = () => {
        const rect = container.getBoundingClientRect();
        width = rect.width + borderOffset * 2;
        height = rect.height + borderOffset * 2;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
      };

      updateSize();

      const draw = (now) => {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        if (dpr !== lastDpr) { lastDpr = dpr; updateSize(); }
        const dt = (now - lastTime) / 1000 || 0;
        time += dt * speed;
        lastTime = now;

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.scale(dpr, dpr);

        // Gradient conic multicolor que rota con el tiempo.
        // Requiere Chrome 88+/Safari 15+ (fallback a color solido).
        let stroke;
        if (typeof ctx.createConicGradient === 'function' && colors.length > 1) {
          const angle = time * rotationSpeed;
          const cg = ctx.createConicGradient(angle, width / 2, height / 2);
          const stops = colors.length;
          for (let i = 0; i < stops; i++) cg.addColorStop(i / stops, colors[i]);
          cg.addColorStop(1, colors[0]);
          stroke = cg;
        } else {
          stroke = colors[0];
        }
        ctx.strokeStyle = stroke;
        ctx.lineWidth = 1;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        const left = borderOffset;
        const top = borderOffset;
        const bw = width - 2 * borderOffset;
        const bh = height - 2 * borderOffset;
        const maxR = Math.min(bw, bh) / 2;
        const r = Math.min(borderRadius, maxR);
        const perim = 2 * (bw + bh) + 2 * Math.PI * r;
        const samples = Math.max(60, Math.floor(perim / 2));

        ctx.beginPath();
        for (let i = 0; i <= samples; i++) {
          const p = i / samples;
          const pt = roundedRectPoint(p, left, top, bw, bh, r);
          const nx = octavedNoise(p * 8, time, 0);
          const ny = octavedNoise(p * 8, time, 1);
          const x = pt.x + nx * displacement;
          const y = pt.y + ny * displacement;
          if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.closePath();
        ctx.stroke();

        raf = requestAnimationFrame(draw);
      };

      const start = () => { if (!raf) raf = requestAnimationFrame(draw); };
      const stop = () => { if (raf) { cancelAnimationFrame(raf); raf = null; } };

      const ro = new ResizeObserver(updateSize);
      ro.observe(container);

      // Pausar cuando no esta visible en pantalla
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => e.isIntersecting ? start() : stop());
      }, { threshold: 0 });
      io.observe(container);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        draw(performance.now());
      } else {
        start();
      }
    });
  })();

  // Timer countdown: descuenta de un ISO datetime hasta ahora.
  document.querySelectorAll('[data-timer]').forEach((timer) => {
    const endStr = timer.getAttribute('end');
    if (!endStr) return;
    const end = new Date(endStr).getTime();
    if (Number.isNaN(end)) return;

    const dEl = timer.querySelector('[data-days]');
    const hEl = timer.querySelector('[data-hours]');
    const mEl = timer.querySelector('[data-minutes]');
    const sEl = timer.querySelector('[data-seconds]');

    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        return false;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
      return true;
    };

    if (!tick()) return;
    let interval = null;
    const start = () => {
      if (interval) return;
      interval = setInterval(() => { if (!tick()) { clearInterval(interval); interval = null; } }, 1000);
    };
    const stop = () => { if (interval) { clearInterval(interval); interval = null; } };
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  });

  // Carrusel: puntos (celular) y rotación automática. Las flechas las maneja
  // snippets/carousel-nav. La rotación se pausa con mouse/touch/foco, fuera de
  // pantalla, con la pestaña oculta y con prefers-reduced-motion.
  document.querySelectorAll('[data-ofertas-carrusel]').forEach((vp) => {
    if (vp.dataset.carruselInit) return;
    vp.dataset.carruselInit = '1';
    const track = vp.querySelector('[data-ofertas-track]');
    const dotsBox = vp.parentElement.querySelector('[data-ofertas-dots]');
    if (!track) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const slots = () => Array.from(track.children);
    const perPage = () => {
      const first = slots()[0];
      if (!first) return 1;
      return Math.max(1, Math.round(track.clientWidth / first.getBoundingClientRect().width));
    };
    const pages = () => Math.max(1, Math.ceil(slots().length / perPage()));
    const current = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return 0;
      return Math.round((track.scrollLeft / max) * (pages() - 1));
    };
    const goTo = (p) => {
      const max = track.scrollWidth - track.clientWidth;
      const n = pages();
      track.scrollTo({ left: n > 1 ? (max * p) / (n - 1) : 0, behavior: reduce ? 'auto' : 'smooth' });
    };

    let holdUntil = 0;
    const pause = (t) => { holdUntil = Date.now() + t; };

    // Puntos
    const paintDots = () => {
      if (!dotsBox) return;
      const c = current();
      Array.from(dotsBox.children).forEach((d, i) => d.setAttribute('aria-selected', String(i === c)));
    };
    const buildDots = () => {
      if (!dotsBox) return;
      const n = pages();
      dotsBox.hidden = n < 2;
      if (dotsBox.children.length !== n) {
        dotsBox.innerHTML = '';
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ofertas-relampago__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Página ' + (i + 1) + ' de ' + n);
          b.addEventListener('click', () => { goTo(i); pause(8000); });
          dotsBox.appendChild(b);
        }
      }
      paintDots();
    };
    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; paintDots(); });
    }, { passive: true });
    new ResizeObserver(buildDots).observe(track);
    buildDots();

    // Rotación automática
    if (vp.dataset.autoplay !== 'true' || reduce) return;
    const ms = Math.max(2500, parseInt(vp.dataset.intervalo, 10) || 4000);
    let timer = null, hover = false, visible = false;
    const tick = () => {
      if (hover || document.hidden || !visible || Date.now() < holdUntil) return;
      const n = pages();
      if (n < 2) return;
      goTo((current() + 1) % n);
    };
    const start = () => { if (!timer) timer = setInterval(tick, ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    vp.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
    vp.addEventListener('pointerleave', () => { hover = false; });
    vp.addEventListener('focusin', () => { hover = true; });
    vp.addEventListener('focusout', () => { hover = false; });
    track.addEventListener('touchstart', () => pause(8000), { passive: true });
    vp.querySelectorAll('[data-recom-prev], [data-recom-next]').forEach((b) => b.addEventListener('click', () => pause(8000)));
    new IntersectionObserver(([e]) => {
      visible = e.isIntersecting;
      visible ? start() : stop();
    }, { threshold: 0.3 }).observe(vp);
  });

  // Los handlers de [data-add-to-cart] y [data-wishlist-toggle] viven
  // ahora en assets/product-card-actions.js (event delegation global).

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-section-id]');
    const input = document.querySelector('[data-faq-search]');
    const list = document.querySelector('[data-faq-list]');
    const noResults = document.querySelector('[data-faq-no-results]');
    if (!input || !list) return;

    const items = list.querySelectorAll('[data-faq-item]');
    const cats = list.querySelectorAll('[data-faq-skip]');

    const normalize = function (s) {
      return (s || '').toString().toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '');
    };

    const debounce = function (fn, wait) {
      let t;
      return function () {
        const args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    };

    const filter = function () {
      const q = normalize(input.value.trim());
      let visible = 0;

      items.forEach(function (item) {
        if (!q) {
          item.hidden = false;
          item.open = false;
          visible++;
          return;
        }
        const haystack = normalize(item.getAttribute('data-search'));
        const match = haystack.indexOf(q) !== -1;
        item.hidden = !match;
        item.open = match;
        if (match) visible++;
      });

      // Al buscar ocultamos las categorías; al limpiar las mostramos.
      cats.forEach(function (c) { c.hidden = !!q; });

      if (noResults) noResults.hidden = visible > 0;
    };

    input.addEventListener('input', debounce(filter, 120));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-announcement"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const root = document.currentScript && document.currentScript.previousElementSibling;
      // El script no tiene relacion directa con su section — buscamos por dismiss_key
      document.querySelectorAll('[data-popup-ann]').forEach((el) => {
        if (el.__popupAnnInit) return;
        el.__popupAnnInit = true;

        const key = el.dataset.dismissKey;
        const persistDays = parseInt(el.dataset.persistDays || '7', 10);
        const delayMs = parseInt(el.dataset.delayMs || '0', 10);
        const scrollPct = parseFloat(el.dataset.scrollPct || '0');

        // Verificar dismiss previo (TTL)
        try {
          const stored = localStorage.getItem(key);
          if (stored) {
            const dismissedAt = parseInt(stored, 10);
            const ttlMs = persistDays * 24 * 60 * 60 * 1000;
            if (Date.now() - dismissedAt < ttlMs) return;
          }
        } catch (_) {}

        let shown = false;
        const show = () => {
          if (shown) return;
          shown = true;
          el.hidden = false;
          el.setAttribute('aria-hidden', 'false');
          // Doble rAF para triggerear la transicion
          requestAnimationFrame(() => requestAnimationFrame(() => {
            el.setAttribute('data-visible', '');
          }));
          // Cargar video lazy
          const video = el.querySelector('[data-popup-ann-video]');
          if (video && video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.load();
            const p = video.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          }
          // Cargar YouTube lazy — construimos el iframe via DOM methods
          // (no innerHTML) para evitar warnings de XSS. ID ya viene escapado
          // desde Liquid, y encodeURIComponent lo blinda.
          const yt = el.querySelector('[data-popup-ann-youtube]');
          if (yt && !yt.__loaded) {
            yt.__loaded = true;
            const id = encodeURIComponent(yt.dataset.ytId || '');
            const iframe = document.createElement('iframe');
            iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + id;
            iframe.setAttribute('allow', 'autoplay; encrypted-media');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('title', 'YouTube video');
            yt.appendChild(iframe);
          }
        };

        const dismiss = () => {
          el.removeAttribute('data-visible');
          setTimeout(() => { el.hidden = true; el.setAttribute('aria-hidden', 'true'); }, 300);
          try { localStorage.setItem(key, String(Date.now())); } catch (_) {}
          // Pausar video / limpiar iframe
          const video = el.querySelector('[data-popup-ann-video]');
          if (video) { try { video.pause(); } catch (_) {} }
        };

        // Hay 2 targets de cierre: el scrim (tap afuera) y la X del popup.
        el.querySelectorAll('[data-popup-ann-close]').forEach((btn) => {
          btn.addEventListener('click', dismiss);
        });
        // Escape cierra
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && el.hasAttribute('data-visible')) dismiss();
        });

        // Trigger 1: delay
        if (delayMs > 0) {
          setTimeout(show, delayMs);
        } else if (scrollPct <= 0) {
          // Sin delay ni scroll: mostrar tras breve delay minimo
          setTimeout(show, 500);
        }
        // Trigger 2: scroll pct — dispara antes que el delay si ocurre
        if (scrollPct > 0) {
          const onScroll = () => {
            const doc = document.documentElement;
            const total = doc.scrollHeight - doc.clientHeight;
            if (total <= 0) return;
            const pct = (doc.scrollTop / total) * 100;
            if (pct >= scrollPct) {
              show();
              window.removeEventListener('scroll', onScroll);
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        }
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-antes-despues"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pad]').forEach((stage) => {
      if (stage.__padInit) return;
      stage.__padInit = true;
      const range = stage.querySelector('[data-pad-range]');
      if (!range) return;
      range.addEventListener('input', () => {
        stage.style.setProperty('--pos', range.value + '%');
        stage.classList.add('is-touched');
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-banner-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pbanner-parallax]');
    if (!roots.length) return;

    // Solo activar en desktop y sin reduced-motion
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!isDesktop || reducedMotion) return;

    const parallaxes = [];
    roots.forEach((root) => {
      const strength = parseInt(root.getAttribute('data-pbanner-parallax'), 10) || 0;
      if (strength <= 0) return;
      const img = root.querySelector('.pbanner__img');
      if (!img) return;
      parallaxes.push({ root, img, strength, visible: false });
    });
    if (!parallaxes.length) return;

    // IntersectionObserver: solo animar cuando el banner esta visible.
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const item = parallaxes.find((p) => p.root === e.target);
          if (item) item.visible = e.isIntersecting;
        });
      },
      { rootMargin: '100px 0px 100px 0px', threshold: 0 }
    );
    parallaxes.forEach((p) => io.observe(p.root));

    // Scroll listener con requestAnimationFrame para 60fps sin jank.
    let rafId = null;
    const update = () => {
      rafId = null;
      const viewportH = window.innerHeight;
      parallaxes.forEach(({ root, img, strength, visible }) => {
        if (!visible) return;
        const rect = root.getBoundingClientRect();
        // Progreso: -1 cuando el banner esta abajo del viewport,
        //            0 cuando esta centrado,
        //            1 cuando esta arriba del viewport.
        const center = rect.top + rect.height / 2;
        const progress = (center - viewportH / 2) / (viewportH / 2 + rect.height / 2);
        const clamped = Math.max(-1, Math.min(1, progress));
        // Multiplicamos por -strength: cuando el banner esta arriba del centro,
        // la imagen se desplaza hacia arriba (mueve mas lento que el scroll).
        const offset = -clamped * strength;
        img.style.setProperty('--pb-parallax-y', offset + 'px');
      });
    };
    const onScroll = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update(); // initial
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-como-usar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Un solo listener delegado por seccion; sin timers ni observers.
    document.querySelectorAll('[data-pcu]').forEach((root) => {
      if (root.__pcuInit) return;
      root.__pcuInit = true;
      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-pcu-step]');
        if (!btn || !root.contains(btn)) return;
        const idx = btn.dataset.pcuStep;
        root.querySelectorAll('[data-pcu-step]').forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-pcu-frame]').forEach((f) => {
          f.classList.toggle('is-active', f.dataset.pcuFrame === idx);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slide-shows"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pss]');
    if (!roots.length) return;

    roots.forEach((root) => {
      root.querySelectorAll('[data-pss-show]').forEach(initShow);
    });

    function initShow(showEl) {
      const rootSection = showEl.closest('[data-pss]');
      const track = showEl.querySelector('[data-pss-track]');
      const slides = Array.from(showEl.querySelectorAll('[data-pss-slide]'));
      const dots = Array.from(showEl.querySelectorAll('[data-pss-dot]'));
      const prev = showEl.querySelector('[data-pss-prev]');
      const next = showEl.querySelector('[data-pss-next]');
      if (!track || !slides.length) return;

      let current = 0;

      const updateNavState = () => {
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
      };

      const setActive = (index) => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
        updateNavState();
      };

      const goTo = (index) => {
        const target = slides[index];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', () => goTo(current - 1));
      if (next) next.addEventListener('click', () => goTo(current + 1));
      dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.index, 10))));

      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((e) => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) {
            const idx = parseInt(visible.target.dataset.index, 10);
            setActive(idx);
          }
        },
        { root: track, threshold: [0.55, 0.75, 0.95] }
      );
      slides.forEach((s) => io.observe(s));

      updateNavState();

      // Celular: posición de flechas y puntos según la imagen del slide
      const viewport = showEl.querySelector('[data-pss-viewport]');
      const media = slides[0].querySelector('.pss__slide-media');
      if (viewport && media) {
        const place = () => {
          const v = viewport.getBoundingClientRect(), m = media.getBoundingClientRect();
          viewport.style.setProperty('--pss-media-mid', (m.top - v.top + m.height / 2) + 'px');
          viewport.style.setProperty('--pss-media-bottom', (m.bottom - v.top) + 'px');
        };
        new ResizeObserver(place).observe(media);
        place();
        rootSection?.classList.add('pss--dots-arriba');
      }

      // Autoplay opcional (setting autoplay + autoplay_interval en segundos).
      // Se pausa cuando el user interactua (hover, focus, touch).
      const autoplaySeconds = parseInt(rootSection?.getAttribute('data-pss-autoplay') || '0', 10);
      if (autoplaySeconds > 0 && slides.length > 1) {
        // Un solo temporizador: avanza solo si la sección está en pantalla, la
        // pestaña visible y nadie la está usando. Al tocar o usar flechas/puntos
        // se pausa unos segundos y luego sigue (antes el toque la detenía para siempre).
        let timer = null, visible = false, hover = false, holdUntil = 0;
        const hold = () => { holdUntil = Date.now() + 8000; };
        const tick = () => {
          if (!visible || hover || document.hidden || Date.now() < holdUntil) return;
          goTo((current + 1) % slides.length);
        };
        const start = () => { if (!timer) timer = setInterval(tick, autoplaySeconds * 1000); };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
        showEl.addEventListener('mouseenter', () => { hover = true; });
        showEl.addEventListener('mouseleave', () => { hover = false; });
        showEl.addEventListener('focusin', () => { hover = true; });
        showEl.addEventListener('focusout', () => { hover = false; });
        track.addEventListener('touchstart', hold, { passive: true });
        [prev, next, ...dots].forEach((b) => b && b.addEventListener('click', hold));
        // Respetar prefers-reduced-motion — no autoplay
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          new IntersectionObserver(([e]) => {
            visible = e.isIntersecting;
            visible ? start() : stop();
          }, { threshold: 0.4 }).observe(showEl);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stats-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pstats]');
    if (!roots.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Parser: extrae numero + prefijo/sufijo del texto original.
    // Ejemplos:
    //   "1000+"     -> { prefix: "",   number: 1000,   suffix: "+",   decimals: 0, hasCommas: false }
    //   "$5,000"    -> { prefix: "$",  number: 5000,   suffix: "",    decimals: 0, hasCommas: true }
    //   "98%"       -> { prefix: "",   number: 98,     suffix: "%",   decimals: 0, hasCommas: false }
    //   "4.9/5"     -> { prefix: "",   number: 4.9,    suffix: "/5",  decimals: 1, hasCommas: false }
    //   "+50k"      -> { prefix: "+",  number: 50,     suffix: "k",   decimals: 0, hasCommas: false }
    // Si no encuentra numero, retorna null y no anima.
    function parseValue(text) {
      const match = text.match(/([^\d\-]*)([-]?\d[\d,]*(?:\.\d+)?)(.*)/);
      if (!match) return null;
      const raw = match[2];
      const hasCommas = raw.includes(',');
      const cleanNumber = parseFloat(raw.replace(/,/g, ''));
      if (!isFinite(cleanNumber)) return null;
      const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
      return {
        prefix: match[1],
        number: cleanNumber,
        suffix: match[3],
        decimals,
        hasCommas
      };
    }

    function formatNumber(n, decimals, hasCommas) {
      const fixed = decimals > 0 ? n.toFixed(decimals) : String(Math.round(n));
      if (!hasCommas) return fixed;
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    // easeOutCubic para que el conteo desacelere hacia el final
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    function animateCount(el, target) {
      const durationMs = 1400;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / durationMs);
        const eased = easeOutCubic(t);
        const current = target.number * eased;
        el.textContent = target.prefix + formatNumber(current, target.decimals, target.hasCommas) + target.suffix;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    roots.forEach((root) => {
      // Asignar index CSS var para stagger delay
      root.querySelectorAll('.pstats__item').forEach((item, i) => {
        item.style.setProperty('--ps-item-index', String(i));
      });

      // Guardar valor original y target parseado en cada .pstats__value
      root.querySelectorAll('.pstats__value').forEach((el) => {
        const original = el.textContent.trim();
        const parsed = parseValue(original);
        if (parsed && !reducedMotion) {
          // Setear a "prefix + 0 + suffix" para que arranque en 0 antes de animar
          el.dataset.animTarget = 'true';
          el.textContent = parsed.prefix + formatNumber(0, parsed.decimals, parsed.hasCommas) + parsed.suffix;
          el.__parsed = parsed;
        }
      });
    });

    // IntersectionObserver: dispara .is-visible + arranca countup cuando entra al viewport.
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-visible');
          // Animar cada value con parsed data
          e.target.querySelectorAll('.pstats__value[data-anim-target="true"]').forEach((el, i) => {
            const parsed = el.__parsed;
            if (!parsed) return;
            // Delay staggered (200ms extra despues del delay CSS del scale)
            setTimeout(() => animateCount(el, parsed), 200 + i * 120);
          });
          io.unobserve(e.target); // animar solo una vez
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -60px 0px' }
    );
    roots.forEach((r) => io.observe(r));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banners"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-promo-banners]').forEach((section) => {
    const track = section.querySelector('[data-pb-track]');
    if (!track) return;

    const autoRotate = section.dataset.autoRotate === 'true';
    const interval = parseInt(section.dataset.interval, 10) || 4000;
    if (!autoRotate) return;

    const items = track.querySelectorAll('[data-pb-item]');
    if (items.length <= 1) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let idx = 0;
    let paused = false;
    let timer = null;
    let currentVideo = null;
    let onEnded = null;

    const scrollTo = (i) => {
      const item = items[i];
      if (!item) return;
      const trackRect = track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const delta = itemRect.left - trackRect.left + track.scrollLeft;
      track.scrollTo({ left: delta, behavior: 'smooth' });
    };

    const clearSchedule = () => {
      if (timer) { clearTimeout(timer); timer = null; }
      if (currentVideo && onEnded) {
        currentVideo.removeEventListener('ended', onEnded);
        currentVideo.pause();
      }
      currentVideo = null;
      onEnded = null;
    };

    const advance = () => {
      idx = (idx + 1) % items.length;
      scrollTo(idx);
      scheduleNext();
    };

    // Elige entre esperar el 'ended' del video o el interval fijo
    const scheduleNext = () => {
      clearSchedule();
      if (paused) return;
      const current = items[idx];
      if (!current) return;
      const video = current.querySelector('[data-pb-video]');
      if (video) {
        currentVideo = video;
        video.currentTime = 0;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // Autoplay bloqueado o video no puede reproducirse: caer al timer
            timer = setTimeout(advance, interval);
          });
        }
        onEnded = () => advance();
        video.addEventListener('ended', onEnded, { once: true });
      } else {
        timer = setTimeout(advance, interval);
      }
    };

    const pause = () => {
      paused = true;
      if (currentVideo) currentVideo.pause();
      if (timer) { clearTimeout(timer); timer = null; }
    };
    const resume = () => {
      if (!paused) return;
      paused = false;
      if (currentVideo) {
        currentVideo.play().catch(() => {});
      } else {
        scheduleNext();
      }
    };

    section.addEventListener('mouseenter', pause);
    section.addEventListener('mouseleave', resume);
    section.addEventListener('touchstart', pause, { passive: true });
    section.addEventListener('touchend', () => { setTimeout(resume, interval); }, { passive: true });

    // Scroll manual: actualizar el idx y reprogramar
    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const trackRect = track.getBoundingClientRect();
        let closestIdx = 0;
        let closestDist = Infinity;
        items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const dist = Math.abs(rect.left - trackRect.left);
          if (dist < closestDist) { closestDist = dist; closestIdx = i; }
        });
        if (closestIdx !== idx) {
          idx = closestIdx;
          scheduleNext();
        }
      }, 200);
    }, { passive: true });

    // Pausar cuando fuera de viewport
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { paused = false; scheduleNext(); }
        else pause();
      });
    }, { threshold: 0 });
    io.observe(section);

    // Flechas prev/next (desktop)
    const prevBtn = section.querySelector('[data-pb-prev]');
    const nextBtn = section.querySelector('[data-pb-next]');
    const goTo = (dir) => {
      idx = (idx + dir + items.length) % items.length;
      scrollTo(idx);
      scheduleNext();
    };
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(1));

    // Actualizar visibilidad de flechas segun posicion
    const updateNav = () => {
      if (!prevBtn && !nextBtn) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
      }
      if (prevBtn) prevBtn.hidden = false;
      if (nextBtn) nextBtn.hidden = false;
    };
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav, { passive: true });
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recomendaciones-carrito"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-recom-cart]');
    if (!section) return;

    const track = section.querySelector('[data-recom-track]');
    if (!track) return;

    const MAX_PRODUCTS = 6;
    const SEED_LIMIT = 3;
    const RECS_PER_SEED = 4;
    const WISHLIST_KEY = 'nqln:wishlist';

    // Guardamos el HTML inicial (los 6 skeleton cards) para poder restaurarlo
    // cuando el carrito se actualiza y toca refrescar la lista.
    const skeletonHTML = track.innerHTML;

    const fetchRecsWith = function (productId, intent) {
      const url = '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' + RECS_PER_SEED +
        '&intent=' + intent;
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    };

    // Intenta primero complementary (accesorios); si Shopify no tiene data
    // suficiente y devuelve vacio, cae a related (productos similares).
    // Esto es comun en tiendas jovenes o productos con poco historial.
    const fetchRecs = function (productId) {
      return fetchRecsWith(productId, 'complementary').then(function (arr) {
        if (arr.length > 0) return arr;
        return fetchRecsWith(productId, 'related');
      });
    };

    const readWishlist = function () {
      try {
        const wl = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(wl) ? wl : [];
      } catch (e) {
        return [];
      }
    };

    let loading = false;

    const load = function () {
      if (loading) return;
      loading = true;

      // Restaurar skeletons (por si es un reload tras cart:updated).
      track.innerHTML = skeletonHTML;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          const items = cart.items || [];
          if (!items.length) {
            section.hidden = true;
            loading = false;
            return null;
          }

          // Carrito con items: revelar seccion (skeleton visible).
          section.hidden = false;

          // Ids en el carrito para dedup + seed.
          const cartIds = items.map(function (it) { return String(it.product_id); });
          const seedIds = cartIds.slice(0, SEED_LIMIT);
          const wishlist = readWishlist();

          return Promise.all(seedIds.map(fetchRecs))
            .then(function (recArrays) {
              // Dedup: excluir productos ya en carrito y en wishlist.
              const seen = new Set();
              cartIds.forEach(function (id) { seen.add(id); });
              wishlist.forEach(function (id) { seen.add(String(id)); });

              const flat = [].concat.apply([], recArrays);
              const unique = [];
              for (let i = 0; i < flat.length; i++) {
                const p = flat[i];
                if (!p || !p.handle) continue;
                const pid = String(p.id);
                if (seen.has(pid)) continue;
                seen.add(pid);
                unique.push(p);
                if (unique.length >= MAX_PRODUCTS) break;
              }
              return unique;
            });
        })
        .then(function (products) {
          if (!products) return null;
          if (!products.length) {
            section.hidden = true;
            return null;
          }
          return Promise.all(products.map(function (p) {
            const url = '/products/' + encodeURIComponent(p.handle) +
              '?section_id=product-card-fragment';
            return fetch(url)
              .then(function (r) { return r.ok ? r.text() : ''; })
              .catch(function () { return ''; });
          }));
        })
        .then(function (htmls) {
          if (!htmls) { loading = false; return; }
          const slots = htmls.filter(Boolean).map(function (html) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;
            const inner = wrapper.querySelector('.shopify-section-product-card-fragment')
              || wrapper.querySelector('#shopify-section-product-card-fragment')
              || wrapper.firstElementChild;
            const content = inner ? inner.innerHTML : html;
            return '<div class="recom-cart__slot">' + content + '</div>';
          });
          if (!slots.length) {
            section.hidden = true;
          } else {
            track.innerHTML = slots.join('');
          }
          loading = false;
        })
        .catch(function () {
          section.hidden = true;
          loading = false;
        });
    };

    // Carga inicial.
    load();

    // Refresco reactivo cuando otras partes del theme (ej. boton "+ al carrito"
    // del product-card) despachan cart:updated. Debounce simple para agrupar
    // rafagas.
    let refreshTimer = null;
    document.addEventListener('cart:updated', function () {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(load, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recomendaciones-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-recom-wishlist]');
    if (!section) return;

    const track = section.querySelector('[data-recom-track]');
    if (!track) return;

    const MAX_PRODUCTS = parseInt(section.dataset.max, 10) || 6;
    const SEED_LIMIT = 3;
    const RECS_PER_SEED = Math.max(4, Math.ceil(MAX_PRODUCTS / SEED_LIMIT) + 1);
    const COMPLEMENTAN = section.dataset.tipo === 'complementan';
    const WISHLIST_KEY = 'nqln:wishlist';
    const skeletonHTML = track.innerHTML;

    const run = function () {
    // 1. Leer wishlist de localStorage.
    let wishlist = [];
    try {
      wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      wishlist = [];
    }
    if (!Array.isArray(wishlist) || !wishlist.length) {
      // Sin wishlist: la seccion queda oculta.
      section.hidden = true;
      return;
    }

    // Hay wishlist: revelar seccion para que el skeleton sea visible mientras
    // resuelven los fetches.
    track.innerHTML = skeletonHTML;
    section.hidden = false;

    // 2. Fetch de recomendaciones para cada item semilla.
    const fetchRecs = function (productId, intent) {
      const url = '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' + RECS_PER_SEED +
        '&intent=' + intent;
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    };

    const seedIds = wishlist.slice(0, SEED_LIMIT);

    // Complementan: primero los complementarios de todas las semillas y
    // despues los similares para completar.
    const intents = COMPLEMENTAN ? ['complementary', 'related'] : ['related'];
    const calls = [];
    intents.forEach(function (intent) {
      seedIds.forEach(function (id) { calls.push(fetchRecs(id, intent)); });
    });

    Promise.all(calls)
      .then(function (recArrays) {
        // 3. Dedup, excluir wishlist y carrito.
        const seen = new Set(wishlist.map(String));
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { items: [] }; })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            (cart.items || []).forEach(function (it) {
              seen.add(String(it.product_id));
            });
            const flat = [].concat.apply([], recArrays);
            const unique = [];
            for (let i = 0; i < flat.length; i++) {
              const p = flat[i];
              if (!p || !p.handle) continue;
              const pid = String(p.id);
              if (seen.has(pid)) continue;
              seen.add(pid);
              unique.push(p);
              if (unique.length >= MAX_PRODUCTS) break;
            }
            return unique;
          });
      })
      .then(function (products) {
        if (!products.length) {
          section.hidden = true;
          return null;
        }
        // 4. Fetch al fragment section por cada handle -> HTML server-rendered.
        return Promise.all(products.map(function (p) {
          const url = '/products/' + encodeURIComponent(p.handle) +
            '?section_id=product-card-fragment';
          return fetch(url)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        }));
      })
      .then(function (htmls) {
        if (!htmls) return;
        const slots = htmls.filter(Boolean).map(function (html) {
          // Shopify envuelve el fragment en:
          //   <div id="shopify-section-product-card-fragment"
          //        class="shopify-section shopify-section-product-card-fragment">
          // Extraemos el contenido interno.
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const inner = wrapper.querySelector('.shopify-section-product-card-fragment')
            || wrapper.querySelector('#shopify-section-product-card-fragment')
            || wrapper.firstElementChild;
          const content = inner ? inner.innerHTML : html;
          return '<div class="recom-wl__slot">' + content + '</div>';
        });

        if (!slots.length) {
          section.hidden = true;
          return;
        }
        track.innerHTML = slots.join('');
      })
      .catch(function () {
        section.hidden = true;
      });
    };

    run();

    // En la pagina de deseos, recalcular cuando se agrega o quita algo.
    if (document.querySelector('[data-wishlist-page]')) {
      let t = null;
      document.addEventListener('wishlist:updated', function () {
        clearTimeout(t);
        t = setTimeout(run, 400);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // ==============================
  // Infinite scroll de la search page
  // Sentinel + IntersectionObserver → fetch batch → append.
  // ==============================
  (function () {
    var infinite = document.querySelector('[data-search-infinite]');
    if (!infinite) return;

    var grid = document.querySelector('.search-page__grid');
    var status = infinite.querySelector('[data-search-load-status]');
    var loadBtn = infinite.querySelector('[data-search-load-btn]');
    if (!grid) return;

    var nextUrl = infinite.getAttribute('data-next-url') || '';
    var totalPages = parseInt(infinite.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(infinite.getAttribute('data-current-page'), 10) || 1;
    var loading = false;

    function getSectionId() {
      var wrapper = infinite.closest('[id^="shopify-section-"]');
      if (wrapper) return wrapper.id.replace('shopify-section-', '');
      return 'search';
    }

    function setLoading(on) {
      loading = on;
      infinite.setAttribute('data-loading', on ? '1' : '0');
      if (status) status.textContent = on ? 'Cargando más resultados…' : '';
    }

    function done() {
      infinite.setAttribute('data-done', '1');
      infinite.removeAttribute('data-loading');
      if (status) status.textContent = 'Has visto todos los resultados.';
      if (loadBtn) loadBtn.hidden = true;
      if (observer) observer.disconnect();
    }

    function loadNext() {
      if (loading) return;
      if (!nextUrl) { done(); return; }
      setLoading(true);

      var sep = nextUrl.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = nextUrl + sep + 'section_id=' + encodeURIComponent(getSectionId());

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var newItems = wrapper.querySelectorAll('.search-page__grid-item');
          if (newItems.length) {
            newItems.forEach(function (item) { grid.appendChild(item); });
          }
          var newInfinite = wrapper.querySelector('[data-search-infinite]');
          if (newInfinite) {
            nextUrl = newInfinite.getAttribute('data-next-url') || '';
            currentPage = parseInt(newInfinite.getAttribute('data-current-page'), 10) || currentPage + 1;
          } else {
            nextUrl = '';
          }
          setLoading(false);
          if (!nextUrl || currentPage >= totalPages) done();
        })
        .catch(function () {
          setLoading(false);
          if (status) status.textContent = 'No se pudo cargar más resultados.';
          if (loadBtn) loadBtn.hidden = false;
        });
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '400px 0px 400px 0px', threshold: 0 });
      observer.observe(infinite);
    } else {
      if (loadBtn) {
        loadBtn.hidden = false;
        loadBtn.addEventListener('click', loadNext);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiendas-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiendas-carousel')) {
    class TiendasCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tcar-track]');
        this.prev = this.querySelector('[data-tcar-prev]');
        this.next = this.querySelector('[data-tcar-next]');
        if (!this.track) return;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onScroll = () => this.updateArrows();
        this.onPause = () => { this.paused = true; };
        this.onResume = () => { this.paused = false; };

        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        ['pointerenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, this.onPause, { passive: true }));
        ['pointerleave', 'focusout'].forEach((e) => this.addEventListener(e, this.onResume));
        this.updateArrows();

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduce) {
          // Solo avanza mientras el carrusel esta en pantalla
          this.io = new IntersectionObserver(([entry]) => {
            entry.isIntersecting ? this.start() : this.stop();
          });
          this.io.observe(this);
        }
      }

      disconnectedCallback() {
        this.stop();
        this.io?.disconnect();
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      step() {
        const item = this.track.querySelector('.tcar__item');
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      atEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      }

      updateArrows() {
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
        if (this.next) this.next.disabled = this.atEnd();
      }

      start() {
        if (this.timer) return;
        const ms = Math.max(2000, parseInt(this.dataset.intervalo, 10) || 3500);
        this.timer = setInterval(() => {
          if (this.paused || document.hidden) return;
          if (this.atEnd()) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.go(1);
          }
        }, ms);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('tiendas-carousel', TiendasCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-wishlist-page]');
    if (!section) return;

    const grid = section.querySelector('[data-wishlist-grid]');
    const empty = section.querySelector('[data-wishlist-empty]');
    const counter = section.querySelector('[data-wishlist-count]');
    const clearBtn = section.querySelector('[data-wishlist-clear]');
    const actionsWrap = section.querySelector('[data-wishlist-actions]');
    const skeleton = section.querySelector('[data-wishlist-skeleton]');
    const WISHLIST_KEY = 'nqln:wishlist';

    // share-buttons snippet lee de esta clave; alias para compatibilidad
    try {
      const wl = localStorage.getItem(WISHLIST_KEY);
      if (wl) localStorage.setItem('nqln_wishlist', wl);
    } catch (_) {}

    // Ignoramos el proximo `wishlist:updated` cuando el trigger vino desde
    // esta misma pagina (para animar el card antes de re-renderizar en vez
    // de un reload instantaneo del grid entero).
    let ignoreNextUpdate = false;

    function readWishlist() {
      try {
        const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(raw) ? raw.map(String) : [];
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(arr) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { count: arr.length }
      }));
    }

    function updateCount(count) {
      if (!counter) return;
      counter.textContent = count === 1
        ? '1 producto guardado'
        : count + ' productos guardados';
    }

    function setState(state) {
      section.dataset.state = state;
      // loading  -> skeleton visible, grid+empty ocultos
      // filled   -> grid visible, skeleton+empty ocultos, botones visibles
      // empty    -> empty visible, skeleton+grid ocultos, botones ocultos
      if (state === 'loading') {
        if (skeleton) skeleton.hidden = false;
        grid.hidden = true;
        empty.hidden = true;
        if (clearBtn) clearBtn.hidden = true;
        if (actionsWrap) actionsWrap.hidden = true;
      } else if (state === 'filled') {
        if (skeleton) skeleton.hidden = true;
        grid.hidden = false;
        empty.hidden = true;
        if (clearBtn) clearBtn.hidden = false;
        if (actionsWrap) actionsWrap.hidden = false;
      } else if (state === 'empty') {
        if (skeleton) skeleton.hidden = true;
        grid.hidden = true;
        empty.hidden = false;
        if (clearBtn) clearBtn.hidden = true;
        if (actionsWrap) actionsWrap.hidden = true;
      }
    }

    // id -> handle guardado por el corazon (assets/product-card-actions.js).
    // Shopify no resuelve /products/{id}.js (da 404): sin el handle no hay
    // forma de leer el producto desde el storefront.
    const HANDLES_KEY = 'nqln:wishlist:handles';
    function readHandles() {
      try {
        const m = JSON.parse(localStorage.getItem(HANDLES_KEY) || '{}');
        return m && typeof m === 'object' && !Array.isArray(m) ? m : {};
      } catch (e) {
        return {};
      }
    }
    function saveHandles(m) {
      try { localStorage.setItem(HANDLES_KEY, JSON.stringify(m)); } catch (_) {}
    }

    // Resuelve un item de la lista (id numerico o handle, en listas
    // compartidas) a su producto. Devuelve:
    //   { product }      encontrado
    //   { gone: true }   el handle ya no existe (404): se puede quitar
    //   null             sin handle o error de red: se deja en la lista
    async function resolveItem(item, handles) {
      const handle = /^\d+$/.test(item) ? handles[item] : item;
      if (!handle) return null;
      try {
        const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
        if (r.status === 404) return { gone: true };
        if (!r.ok) return null;
        const p = await r.json();
        return p && p.handle ? { product: p } : null;
      } catch (e) {
        return null;
      }
    }

    // Fetcher del fragment del card (server-rendered con TODOS los settings).
    async function fetchCardFragment(handle) {
      try {
        const url = '/products/' + encodeURIComponent(handle) + '?section_id=product-card-fragment';
        const r = await fetch(url);
        if (!r.ok) return '';
        return await r.text();
      } catch (e) {
        return '';
      }
    }

    // Extrae el contenido interno del wrapper `.shopify-section-*`.
    function extractSlot(html, productId) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const inner = wrapper.querySelector('.shopify-section-product-card-fragment')
        || wrapper.querySelector('#shopify-section-product-card-fragment')
        || wrapper.firstElementChild;
      const content = inner ? inner.innerHTML : html;
      const slot = document.createElement('div');
      slot.className = 'wishlist-page__slot';
      slot.dataset.wishlistSlot = productId;
      slot.innerHTML = content;
      return slot;
    }

    // Modo "wishlist compartida": si viene ?share=id1,id2,... por URL,
    // renderiza esos productos SIN tocar el localStorage del visitor.
    // Ofrece boton "Guardar en mi lista" para copiar los IDs a su propia lista.
    let isSharedView = false;
    let sharedIds = [];
    let sharedProducts = [];
    try {
      const params = new URLSearchParams(window.location.search);
      const shareParam = params.get('share');
      if (shareParam) {
        const parsed = shareParam.split(',').map(s => s.trim()).filter(Boolean);
        if (parsed.length) { isSharedView = true; sharedIds = parsed; }
      }
    } catch (_) {}

    function ensureSharedBanner() {
      if (!isSharedView) return;
      if (section.querySelector('[data-wishlist-shared-banner]')) return;
      const heading = section.querySelector('.wishlist-page__heading');
      if (heading) heading.textContent = 'Lista de deseos compartida';
      const wrap = section.querySelector('.page-width');
      const header = section.querySelector('.wishlist-page__header');
      if (!wrap || !header) return;
      const banner = document.createElement('div');
      banner.setAttribute('data-wishlist-shared-banner', '');
      banner.className = 'wishlist-page__shared-banner';
      banner.innerHTML = `
        <p>Estás viendo una lista compartida. Guárdala en tu propia lista de deseos.</p>
        <button type="button" class="wishlist-page__save-shared" data-wishlist-save-shared>
          Guardar en mi lista
        </button>
      `;
      wrap.insertBefore(banner, header.nextSibling);
      // En shared view, ocultar acciones del owner (compartir/vaciar)
      if (actionsWrap) actionsWrap.hidden = true;

      const saveBtn = banner.querySelector('[data-wishlist-save-shared]');
      if (saveBtn) {
        saveBtn.addEventListener('click', () => {
          // Merge con la lista existente del visitor (sin duplicados)
          const current = readWishlist();
          const handles = readHandles();
          sharedProducts.forEach((p) => { handles[String(p.id)] = p.handle; });
          saveHandles(handles);
          const merged = Array.from(new Set([...current, ...sharedProducts.map((p) => String(p.id))]));
          saveWishlist(merged);
          try { localStorage.setItem('nqln_wishlist', JSON.stringify(merged)); } catch (_) {}
          saveBtn.textContent = '¡Guardado!';
          saveBtn.disabled = true;
          setTimeout(() => { window.location.href = window.location.pathname; }, 900);
        });
      }
    }

    async function renderWishlist() {
      ensureSharedBanner();
      const ids = isSharedView ? sharedIds : readWishlist();
      updateCount(ids.length);

      if (!ids.length) {
        setState('empty');
        return;
      }

      setState('loading');

      // 1. Resolver cada item a su producto (por handle).
      const handles = readHandles();
      const results = await Promise.all(ids.map((id) => resolveItem(id, handles)));
      const validPairs = [];
      results.forEach((res, i) => {
        if (res && res.product) validPairs.push({ id: String(res.product.id), product: res.product });
      });
      sharedProducts = isSharedView ? validPairs.map((p) => p.product) : [];

      // Solo se quitan los productos que ya no existen (404). Lo que no se
      // pudo resolver (sin handle o error de red) se queda: antes se borraba
      // la lista entera cuando fallaba la consulta.
      if (!isSharedView) {
        const gone = ids.filter((id, i) => results[i] && results[i].gone);
        if (gone.length) {
          const kept = ids.filter((id) => !gone.includes(id));
          gone.forEach((id) => { delete handles[id]; });
          saveHandles(handles);
          ignoreNextUpdate = true;
          saveWishlist(kept);
        }
      }

      updateCount(validPairs.length);
      if (!validPairs.length) {
        setState('empty');
        return;
      }

      // 2. Fetch de fragments en paralelo.
      const htmls = await Promise.all(
        validPairs.map((pair) => fetchCardFragment(pair.product.handle))
      );

      // 3. Insertar en grid.
      grid.innerHTML = '';
      htmls.forEach((html, i) => {
        if (!html) return;
        const slot = extractSlot(html, validPairs[i].id);
        grid.appendChild(slot);
      });

      if (!grid.children.length) {
        setState('empty');
        return;
      }

      setState('filled');
    }

    // Cuando el visitante toca el corazon de un card DENTRO de esta pagina,
    // animamos la salida del slot antes de re-renderizar. Escuchamos el click
    // en la fase capture para actuar antes que el handler global emita
    // `wishlist:updated`.
    grid.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      const slot = btn.closest('[data-wishlist-slot]');
      if (!slot) return;
      // Verificamos si el click va a QUITAR (card actualmente activo).
      if (!btn.classList.contains('is-active')) return;
      // Animar salida. El handler global correra despues y disparara
      // wishlist:updated -> renderWishlist().
      slot.classList.add('is-removing');
    });

    // Boton "Vaciar lista".
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!window.confirm('Vaciar toda tu lista de deseos?')) return;
        saveWishlist([]);
        // saveWishlist ya dispara wishlist:updated que llama a renderWishlist.
      });
    }

    // Listener global: cualquier cambio de wishlist re-renderiza.
    document.addEventListener('wishlist:updated', function () {
      if (ignoreNextUpdate) {
        ignoreNextUpdate = false;
        return;
      }
      renderWishlist();
    });

    // Carga inicial.
    renderWishlist();
  })();

  } catch(e) { console.error(e); }
})();
})();
